function showError(errElm, errTitleElm, mes) {
  errElm.show();
  errTitleElm.text(mes);
}

function hideError(errElm, errTitleElm) {
  errElm.hide();
  errTitleElm.text('');
}

function GetPriceByListProductIds(productIdsArr, callback) {
  const customerInfoElm = $('#customer-infor');

  const customerInfo = {
    customerId: customerInfoElm.data('customer-id'),
    partnerCode: customerInfoElm.data('partner-code'),
    customerEmail: customerInfoElm.data('customer-email'),
  };

  if(!customerInfo.customerId) return;

  $.ajax({
    method: 'POST',
    url: `${window.partner.omsGetPriceByListProductIds}`,
    headers: {
      'Ocp-Apim-Subscription-Key': window.partner.omsApimSubscriptionKey,
      'issuer': window.partner.storeId,
      'Accept-Language': 'en-US'
    },
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    data: JSON.stringify({
      'storeid': window.partner.storeId,
      'customeremail': customerInfo.customerEmail.toLowerCase(),
      'partnercode': customerInfo.partnerCode,
      'listproductid': JSON.stringify(productIdsArr)
    })     
  }).done(result => {
    if (result) {
      const resultValue = JSON.parse(result?.value);
      callback(resultValue);
    }
  }).fail(err => {
    console.log('err: ', err);
    callback();
  });
}

function getValidatePartnerQuota(cartItems, callback) {
  const customerInfoElm = $('#customer-infor');

  const customerInfo = {
    customerId: customerInfoElm.data('customer-id'),
    partnerCode: customerInfoElm.data('partner-code'),
    customerEmail: customerInfoElm.data('customer-email'),
  };

  if(!customerInfo.customerId) {
    callback();
    return;
  };

  const dataItems = cartItems.map(item => ({
    variantid: item.variant_id,
    productid: item.product_id,
    quantity: item.quantity
  }));

  const storeId = window.partner.storeId.toString();
  const dataString = JSON.stringify({
    storeid: storeId,
    customeremail: customerInfo.customerEmail,
    partnerCode: customerInfo.partnerCode,
    cartitemids: dataItems
  });

  $.ajax({
    method: 'POST',
    async: false,
    url: `${window.partner.omsValidateOrderQuotation}`,
    headers: {
      'Ocp-Apim-Subscription-Key': window.partner.omsApimSubscriptionKey,
      'issuer': storeId,
      'Accept-Language': 'en-US'
    },
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify({
      'jsonstr': dataString
    })

  }).done(result => {
    if (result) {
      const valueReult = JSON.parse(result.value);
      callback(valueReult[0]);
    }
  })
  .fail(err => {
    console.log('err: ', err);
  });
};

/**
 * Plugin to handle the Google Map
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMap',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.element = $(element);
    this.options = JSON.parse(this.element.attr('data-section-settings'));
    this.locations = [];
    this.markers = [];

    this.element.on('click', '[data-action="toggle-store"]', this._toggleStore.bind(this));
    this.element.on('click', '.featured-map__store-item', this._activateStore.bind(this));
    this.element.on('shopify:block:select', this._blockSelected.bind(this));

    this.googleMapContainer = this.element.find('.featured-map__gmap').get(0);

    if (this.options['apiKey'] && this.options['mapAddresses'].length > 0) {
      var $script = $('script[src*="' + this.options['apiKey'] + '&"]'),
        self = this;

      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.options['apiKey']
        ).then(function() {
          self._initMap();
        });
      } else {
        this._initMap();
      }
    }

    $(window).on('resize.trademarkMap', this._repositionMap.bind(this));
  }

  Plugin.prototype.destroy = function() {
    $(window).off('resize.trademarkMap');
  };

  Plugin.prototype._blockSelected = function(event) {
    this._selectStore($(event.target));
  };

  Plugin.prototype._toggleStore = function(event) {
    this._selectStore($(event.currentTarget).closest('.featured-map__store-item'));
  };

  Plugin.prototype._activateStore = function(event) {
    this._selectStore($(event.currentTarget));
  };

  Plugin.prototype._selectStore = function(storeElement) {
    storeElement.addClass('featured-map__store-item--active');

    if (window.matchMedia('screen and (max-width: 800px)').matches) {
      storeElement.find('.featured-map__store-inner').slideDown()
        .end().find('.plus-button').addClass('plus-button--active');

      storeElement.siblings('.featured-map__store-item--active')
        .find('.featured-map__store-inner').slideUp()
        .end().find('.plus-button').removeClass('plus-button--active');
    }

    storeElement.siblings('.featured-map__store-item--active').removeClass('featured-map__store-item--active');

    this._repositionMap();
    this._setNewCenter(storeElement.attr('data-store-index'));
  };

  Plugin.prototype._initMap = function() {
    var geocoder = new google.maps.Geocoder(),
      self = this;

    var mapOptions = {
      zoom: self.options['zoom'],
      draggable: false,
      clickableIcons: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      disableDefaultUI: true
    };

    this.googleMap = new google.maps.Map(this.googleMapContainer, mapOptions);
    var styledMapType = new google.maps.StyledMapType(JSON.parse(this.element.find('[data-gmap-style]').html()));

    this.googleMap.mapTypes.set('styled_map', styledMapType);
    this.googleMap.setMapTypeId('styled_map');

    this._repositionMap();

    // We need to geocode each addresses individually
    this.options['mapAddresses'].forEach(function(address, index) {
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {

          }
        } else {
          if (index === 0) {
            self.googleMap.setCenter(results[0].geometry.location);
          }

          self.locations[index] = results[0].geometry.location;

          var icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: index === 0 ? self.options['markerActiveColor'] : self.options['markerColor'],
            fillOpacity: 1,
            anchor: new google.maps.Point(15,55),
            strokeWeight: 0,
            scale: window.matchMedia('screen and (max-width: 559px)').matches ? 0.5 : (index === 0 ? 0.7 : 0.5)
          };

          self.markers[index] = new google.maps.Marker({
            map: self.googleMap,
            position: results[0].geometry.location,
            icon: icon
          });
        }
      });
    });
  };

  Plugin.prototype._setNewCenter = function(index) {
    var self = this,
      indexAsInt = parseInt(index);

    this.googleMap.panTo(this.locations[indexAsInt]);

    this.markers.forEach(function(marker, markerIndex) {
      if (markerIndex === indexAsInt) {
        marker.icon.fillColor = self.options['markerActiveColor'];
        marker.icon.scale = window.matchMedia('screen and (max-width: 559px)').matches ? 0.5 : 0.7;
      } else {
        marker.icon.fillColor = self.options['markerColor'];
        marker.icon.scale = 0.5;
      }

      marker.setMap(self.googleMap);
    });
  };

  /**
   * Reposition the GMap container (which allows to re-use it on mobile and desktop)
   *
   * @private
   */
  Plugin.prototype._repositionMap = function() {
    var container = null;

    if (window.matchMedia('screen and (min-width: 801px)').matches) {
      container = this.element.find('.featured-map__map-container--desktop');
    } else {
      container = this.element.find('.featured-map__store-item--active .featured-map__map-container--mobile');
    }

    container.append(this.googleMapContainer);

    var center = this.googleMap.getCenter();
    google.maps.event.trigger(this.googleMap, 'resize');
    this.googleMap.setCenter(center);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle the header search
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkHeaderSearch',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.headerSearch = $(element);
    this.headerSearchForm = this.headerSearch.find('.header-search__form');
    this.headerInput = this.headerSearch.find('.header-search__input');
    this.headerSearchResults = this.headerSearch.find('.header-search__results-wrapper');

    this.searchResultsTemplate = Template7.compile($('#search-results-template').html());
    this.searchMode = "product",
    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.sidebarNavInstance = $('.sidebar-nav').data('plugin_trademarkMobileSidebar');
    this.miniCartInstance = $('.mini-cart').data('plugin_trademarkMiniCart');

    $('[data-action="open-search"]').on('click', $.proxy(this._openSearch, this));
    // $('[data-action="close-search"]').on('click', $.proxy(this._closeSearch, this));
    $('[data-action="close-search"]').on('click', function(){
    	$('.header-search__input').val("");
        $(".header-search__results").hide();
      	return false;
    });

    this.headerInput.on('keyup', $.proxy(this._initSearch, this));
    this.headerSearchForm.on('submit', $.proxy(this._formSubmitted, this));
  }

  Plugin.prototype.destroy = function() {
    $('[data-action="open-search"]').off('click');
    $('[data-action="close-search"]').off('click');

    this.headerSearch.removeData('plugin_trademarkHeaderSearch');
    this.headerInput.off('keyup');
    this.headerSearchForm.off('submit');
    this.body.off('.trademarkHeaderSearch');
  };

  Plugin.prototype._openSearch = function(event) {
    var self = this;

    if($('.header-search').hasClass('header-search--open')){

    	self._closeSearch(event);
    }
    else{
      // If either mobile sidebar or mini-cart are open we must first close them, otherwise we open directly

      if (this.sidebarNavInstance.state === 'opening' || this.sidebarNavInstance.state === 'opened') {
        this.sidebarNavInstance._toggleSidebar(event);

        $(document).one('closed.trademarkMobileSidebar', function() {
          self._doOpenSearch();
        });
      } else if (undefined !== this.miniCartInstance && (this.miniCartInstance.state === 'opening' || this.miniCartInstance.state === 'opened')) {
       // this.miniCartInstance._toggleMiniCart(event);
        $('.mini-cart').removeClass('mini-cart--open');
        self._doOpenSearch();
        // $(document).one('closed.trademarkMiniCart', function() {
        //   self._doOpenSearch();
        //   });
      } else {
        this._doOpenSearch(); // Both are closed so we can open directly

      }

		  event.preventDefault();
    }
  };

  Plugin.prototype._closeSearch = function(event) {
    this.body.removeClass('no-scroll');
    this.pageOverlay.removeClass('page__overlay--open');
    this.headerSearch.removeClass('header-search--open');
    $(".header-search__results-wrapper").hide();
    this.body.off('.trademarkHeaderSearch');

    $('[data-action="open-search"]').removeClass("open");

    event.preventDefault();
  };

  Plugin.prototype._doOpenSearch = function() {
    var self = this;

    this.body.addClass('no-scroll');
    this.pageOverlay.addClass('page__overlay--open');

    this.headerSearch.addClass('header-search--open');
    this.headerSearch.one('transitionend', function() {
      self._cursorFocus(self.headerInput);
    });

    this.body.on('keyup.trademarkHeaderSearch', function(event) {
      if (event.keyCode == 27) {
        self._closeSearch(event);
      }
    });

    this.body.on('click.trademarkHeaderSearch', function(outsideEvent) {
      if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
        self._closeSearch(outsideEvent);
      }
    });

    setTimeout(function(){ $('[data-action="open-search"]').addClass("open"); }, 500);
  };

  Plugin.prototype._initSearch = function(event) {
    var target = $(event.currentTarget);

    if ((event.keyCode ? event.keyCode : event.which) != 13) {
      clearTimeout(target.data('timeout'));
      target.data('timeout', setTimeout($.proxy(this._doSearch, this), 400));
    }
  };

  Plugin.prototype._doSearch = function(event) {
    $(".header-search__results-wrapper").show();
    // No autocompletion on mobile
    // if (Modernizr.mq('(max-width: 559px)')) {
    //   return;
    // }

    // If we are on mobile, we do a single search that will get all resources, based on the setting. If tablet and higher, we do two Ajax calls: one
    // that will fetch product only, and another one that will fetch anything else

    if (this.headerInput.val().trim() === '') {
      this.headerSearchResults.empty();

      return; // No need to search if it's empty
    } else {
      this.headerSearchResults.html(this.searchResultsTemplate({is_loading: true}));
    }

    if (this.searchMode === 'product') {
      this._doCompleteSearch();
    } else {
      this._doSeparateSearch();
    }
  };

  function renderSearchResultsTemplate(self, data, newResults) {
    self.headerSearchResults.html(self.searchResultsTemplate({
      is_loading: false,
      split_search: false,
      on_sale_label: window.languages.productLabelsOnSale,
      results: newResults ? newResults : data['results'],
      has_results: (data['results'].length > 0),
      results_count: data['results_count'],
      results_label: data['results_label'],
      results_url: encodeURI(data['url'] + '&filter.v.price.gte=1&options[prefix]=last&type=' + self.searchMode)
    }));

    $('.header-search__results-wrapper').removeClass("overlay");
  }

  function renderSeparateSearchResultsTpl(self, data1, data2, newResults) {
    self.headerSearchResults.html(self.searchResultsTemplate({
      is_loading: false,
      split_search: true,
      on_sale_label: window.languages.productLabelsOnSale,
      has_products_results: (data1[0]['results'].length > 0),
      has_others_results: (data2[0]['results'].length > 0),
      products: {
        results: newResults,
        results_count: data1[0]['results_count'],
        results_label: data1[0]['results_label'],
        results_url: (data1[0]['url'] + '&type=' + searchTypes[0])
      },
      others: {
        results: data2[0]['results'],
        results_count: data2[0]['results_count'],
        results_label: data2[0]['results_label'],
        results_url: (data2[0]['url'] + '&type=' + searchTypes.slice(1).join(','))
      }
    }));

    $('.header-search__results-wrapper').removeClass("overlay");
  }

  function updateSearchItemPrice(item) {
    return {
      ...item,
      price: Shopify.formatMoney(item.price, window.theme.moneyFormat),
      compare_at_price: Shopify.formatMoney(item.compare_at_price, window.theme.moneyFormat),
      result_var_price: Shopify.formatMoney(item.result_var_price, window.theme.moneyFormat),
      result_compare_at_price: Shopify.formatMoney(item.result_compare_at_price, window.theme.moneyFormat),
    }
  }

  function getPriceForSearchListing(listProductId, self, data) {
      GetPriceByListProductIds(listProductId, function(resultValue) {
        if(resultValue) {
          const newResults = data['results'].map((item) => {
            const partnerObj = resultValue.find((partnerItem) => {
              return partnerItem.productid == item.product_id;
            });
    
            if (!partnerObj) {
              return updateSearchItemPrice(item);
            };
    
            const variants = partnerObj.variant;
    
            const variant = variants.find((v) => {
              return v.id == item.variant_id
            });
    
            if (!variant) {
              return updateSearchItemPrice(item);
            }
    
            const price = item.result_price ? item.price : item.result_var_price;
            const comparePrice = item.result_price ? item.compare_at_price : item.result_compare_at_price;
    
            const partnerPrice = variant.price * 100;
    
            const isComparePrice = item.result_price ? item.on_sale : item.result_on_sale;
    
            const newPrice = isComparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
            const newComparePrice = isComparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    
            return {
              ...item,
              price: Shopify.formatMoney(newPrice, window.theme.moneyFormat),
              compare_at_price: Shopify.formatMoney(newComparePrice, window.theme.moneyFormat),
              result_var_price: Shopify.formatMoney(newPrice, window.theme.moneyFormat),
              result_compare_at_price: Shopify.formatMoney(newComparePrice, window.theme.moneyFormat),
            }
          });
    
          // Render template
          renderSearchResultsTemplate(self, data, newResults);
        }
        else {
          const newResults = data['results'].map((item) => {
            return updateSearchItemPrice(item);
          });
    
          renderSearchResultsTemplate(self, data, newResults);
        }
      });
  }

  Plugin.prototype._doCompleteSearch = function(event) {
    var self = this;
    var input_search = this.headerInput.val().replace("/", " ");
    var searchRouter = window.theme.isDefaultLanguage ? '/search?view=json' : `/${window.theme.locale}/search?view=json`;

    $.ajax({
      method: 'GET',
      url: searchRouter,
      dataType: 'json',
      data: {
        q: input_search + '*',
        type: this.searchMode,
        'options[prefix]': 'last',
        'filter.v.price.gte': '1'
      }
    }).then(function(data) {
      $('.header-search__results-wrapper').addClass('overlay');
      
      if($('#customer-infor').data('customer-id') !== '') {
        const listProductId = data['results'].map((item) => {
          return item.product_id;
        });

        //update price for mini search
        getPriceForSearchListing(listProductId, self, data);
      }
      else {
        const newResults = data['results'].map((item) => {
          return updateSearchItemPrice(item);
        });

        renderSearchResultsTemplate(self, data, newResults);

      }
    }).fail(function(err) {
      console.log('error api /search: ', err);
    });
  };

  Plugin.prototype._doSeparateSearch = function(event) {
    var searchTypes = this.searchMode.split(','),
        self = this;
    var searchRouter = window.theme.isDefaultLanguage ? '/search?view=json' : `/${window.theme.locale}/search?view=json`;

    var firstSearch = $.ajax({
      method: 'GET',
      url: searchRouter,
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: searchTypes[0]
      }
    });

    var lastSearch = $.ajax({
      method: 'GET',
      url: searchRouter,
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: searchTypes.slice(1).join(',')
      }
    });

    $.when(firstSearch, lastSearch).then(function(data1, data2) {
      $('.header-search__results-wrapper').addClass('overlay');
      
      if($('#customer-infor').data('customer-id') !== '') {
        const listProductId = data1[0]['results'].map((item) => {
          return item.product_id;
        });

          GetPriceByListProductIds(listProductId, function(resultValue) {
            if(resultValue) {
              const newResults = data1[0]['results'].map((item) => {
                const partnerObj = resultValue.find((partnerItem) => {
                  return partnerItem.productid == item.product_id;
                });
        
                if (!partnerObj) {
                  return updateSearchItemPrice(item);
                };
        
                const variants = partnerObj.variant;
        
                const variant = variants.find((v) => {
                  return v.id == item.variant_id
                });
        
                if (!variant) {
                  return updateSearchItemPrice(item);
                }
        
                const price = item.result_price ? item.price : item.result_var_price;
                const comparePrice = item.result_price ? item.compare_at_price : item.result_compare_at_price;
        
                const partnerPrice = variant.price * 100;
        
                const isComparePrice = item.result_price ? item.on_sale : item.result_on_sale;
        
                const newPrice = isComparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
                const newComparePrice = isComparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
        
                return {
                  ...item,
                  price: Shopify.formatMoney(newPrice, window.theme.moneyFormat),
                  compare_at_price: Shopify.formatMoney(newComparePrice, window.theme.moneyFormat),
                  result_var_price: Shopify.formatMoney(newPrice, window.theme.moneyFormat),
                  result_compare_at_price: Shopify.formatMoney(newComparePrice, window.theme.moneyFormat),
                }
              });
  
              renderSeparateSearchResultsTpl(self, data1, data2, newResults)
            }
            else {
              const newResults = data1[0]['results'].map((item) => {
                return updateSearchItemPrice(item);
              });
      
              renderSeparateSearchResultsTpl(self, data1, data2, newResults)
            }
          });

      }
      else {
        const newResults = data1[0]['results'].map((item) => {
          return updateSearchItemPrice(item);
        });

        renderSeparateSearchResultsTpl(self, data1, data2, newResults)

      }

    });
  };

  Plugin.prototype._formSubmitted = function(event) {
    if(this.headerInput.val().trim() != ''){
      this.headerInput.val(this.headerInput.val() + '*');
      return true;
    }
    else {
      $('.header-search__input').val("");
      this._doOpenSearch();
      $(".header-search__results-wrapper").html("<p class='error'>Search field cannot be empty</p>");
      $(".header-search__results-wrapper").show();
      return false;
    }
  };

  /**
   * Allow to give focus on an item while preserving scroll position
   */
  Plugin.prototype._cursorFocus = function(element) {
    var x = window.scrollX,
      y = window.scrollY;

    element.focus();
    window.scrollTo(x, y);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle home slideshow
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkHomeSlideshow',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.slideshow = $(element);
    this.slideshowAnchor = this.slideshow.find('.slideshow--anchor');
    this.slideshowAnchorSlides = this.slideshowAnchor.find('.slideshow__slide');
    this.slideshowMain = this.slideshow.find('.slideshow--main');
    this.slideshowMainSlides = this.slideshowMain.find('.slideshow__slide');
    this.slideshowSlidesCount = this.slideshowMainSlides.length;
    this.slideshowCount = this.slideshow.find('.slideshow__current-slide');
    this.slideshowButtons = this.slideshow.find('.slideshow__nav-button');
    this.hasTransitionPending = false;
    this.paused = false;

    this.slideshow.find('.slideshow__nav-next').on('click', $.proxy(this.nextSlide, this));
    this.slideshow.find('.slideshow__nav-prev').on('click', $.proxy(this.prevSlide, this));
    this.slideshow.on('swipeleft', $.proxy(this.nextSlide, this));
    this.slideshow.on('swiperight', $.proxy(this.prevSlide, this));

    // If we have the autoplay set up, we activate it
    this.hasAutoplay = (this.slideshow.attr('data-autoplay') === 'true');
    this.autoplayCycleSpeed = parseInt(this.slideshow.attr('data-cycle-speed'));

    if (this.hasAutoplay) {
      this._setupAutoplay();
    }

    // We simulate an initial change so that various events can be hooked up correctly
    var firstSlide = this.slideshowMainSlides.eq(0);
    this._didChange(firstSlide, firstSlide);

    // Setup the video (if any)
    this.players = plyr.setup(this.slideshowMain.find('.plyr-video[data-type]'), {
      controls: ['play-large'],
      iconPrefix: 'icon-video'
    }) || [];

    var self = this;

    this.players.forEach(function(player) {
      player.on('play', $.proxy(self._videoStarted, self));
      player.on('pause ended', $.proxy(self._videoEnded, self));
    });
  }

  /**
   * Clear the memory and remove any listener
   */
  Plugin.prototype.destroy = function() {
    this.slideshow.off('swipeleft swiperight');
    this.slideshowButtons.off('click');
    clearInterval(this.timer);

    this.players.forEach(function(player) {
      player.destroy();
    });

    this.slideshow.removeData('plugin_trademarkHomeSlideshow');
  };

  /**
   * Move to the next slide
   */
  Plugin.prototype.nextSlide = function() {
    var currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = currentAnchorSlide.next('.slideshow__slide'),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = currentMainSlide.next('.slideshow__slide');

    if (prevOrNextAnchorSlide.length === 0) {
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.first();
    }

    if (prevOrNextMainSlide.length === 0) {
      prevOrNextMainSlide = (prevOrNextMainSlide.length !== 0) ? prevOrNextMainSlide : this.slideshowMainSlides.first();
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, 'next');

    return false;
  };

  /**
   * Move to the previous slide
   */
  Plugin.prototype.prevSlide = function() {
    var currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = currentAnchorSlide.prev('.slideshow__slide'),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = currentMainSlide.prev('.slideshow__slide');

    if (prevOrNextAnchorSlide.length === 0) {
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.last();
    }

    if (prevOrNextMainSlide.length === 0) {
      prevOrNextMainSlide = (prevOrNextMainSlide.length !== 0) ? prevOrNextMainSlide : this.slideshowMainSlides.last();
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, 'previous');

    return false;
  };

  /**
   * Move to a specific slide
   */
  Plugin.prototype.goToSlide = function(index) {
    var desiredIndex = parseInt(index) - 1,
      currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.eq(desiredIndex === 0 ? 1 : (desiredIndex + 1) % this.slideshowSlidesCount),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = this.slideshowMainSlides.eq(desiredIndex),
      currentIndex = this.slideshowMainSlides.index(currentMainSlide);

    if (currentIndex === desiredIndex) {
      return;
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, (currentIndex > desiredIndex) ? 'previous' : 'next');

    return false;
  };

  /**
   * Pause the autoplay
   */
  Plugin.prototype.pause = function() {
    this.paused = true;
  };

  /**
   * Restart the autoplay
   */
  Plugin.prototype.play = function() {
    this.paused = false;
  };

  /**
   * Add the various classes to properly animate all the slides
   *
   * @param currentAnchorSlide
   * @param prevOrNextAnchorSlide
   * @param currentMainSlide
   * @param prevOrNextMainSlide
   * @param direction
   * @private
   */
  Plugin.prototype._move = function(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, direction) {
    if (this.hasTransitionPending) {
      return;
    }

    if (this.hasAutoplay && !this.paused) {
      this._clearAutoplay();
    }

    var self = this;

    this.slideshowButtons.attr('disabled', 'disabled');

    this._willChange(currentMainSlide, prevOrNextMainSlide);

    if (Modernizr.cssanimations) {
      var animationClasses = 'slideshow__slide--animating ' + (direction === 'next' ? 'slideshow__slide--animating-rtl' : 'slideshow__slide--animating-ltr');

      // 1st: add all the classes needed to trigger animations
      prevOrNextAnchorSlide.addClass(animationClasses);
      prevOrNextMainSlide.addClass(animationClasses);
      currentMainSlide.addClass('slideshow__slide--removing');
      currentAnchorSlide.addClass('slideshow__slide--removing');

      // 2nd: listen to the event to properly removing the classes when animations are over
      prevOrNextAnchorSlide.find('.slideshow__media-container').one('webkitAnimationEnd animationend', function() {
        prevOrNextAnchorSlide.removeClass(animationClasses).addClass('slideshow__slide--active');
        currentAnchorSlide.removeClass('slideshow__slide--active slideshow__slide--removing');
      });

      prevOrNextMainSlide.find('.slideshow__media').one('webkitAnimationEnd animationend', function() {
        prevOrNextMainSlide.removeClass(animationClasses).addClass('slideshow__slide--active');
        currentMainSlide.removeClass('slideshow__slide--active slideshow__slide--removing');

        self.slideshowCount.text(prevOrNextMainSlide.attr('data-slide-index'));
        self.slideshowButtons.removeAttr('disabled');

        self._didChange(currentMainSlide, prevOrNextMainSlide);
      });
    } else {
      prevOrNextAnchorSlide.addClass('slideshow__slide--active');
      currentAnchorSlide.removeClass('slideshow__slide--active');

      prevOrNextMainSlide.addClass('slideshow__slide--active');
      currentMainSlide.removeClass('slideshow__slide--active');

      this.slideshowCount.text(prevOrNextMainSlide.attr('data-slide-index'));
      this.slideshowButtons.removeAttr('disabled');

      this._didChange(currentMainSlide, prevOrNextMainSlide);
    }
  };

  /**
   * Callback that is called before the slide changes
   */
  Plugin.prototype._willChange = function(previousSlide, newSlide) {
    this.hasTransitionPending = true;

    if (!previousSlide.hasClass('slideshow__slide--video')) {
      return;
    }

    // If the previous slide (the one that gonna disappear) is a video, we pause it

    plyr.get(previousSlide.get(0))[0].pause();
  };

  /**
   * Callback that is called after the slide has changed
   */
  Plugin.prototype._didChange = function(previousSlide, newSlide) {
    this.hasTransitionPending = false;

    if (this.hasAutoplay && !this.paused) {
      this._setupAutoplay();
    }
  };

  /**
   * Setup the autoplay which allows to automatically change slide
   */
  Plugin.prototype._setupAutoplay = function() {
    var self = this;

    // If there is a previous timer, clear it
    this._clearAutoplay();

    this.timer = setInterval(function() {
      if (!self.paused) {
        self.nextSlide();
      }
    }, this.autoplayCycleSpeed);
  };

  /**
   * Clear the autoplay
   */
  Plugin.prototype._clearAutoplay = function() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = null;
  };

  /**
   * Called when a video starts playing
   */
  Plugin.prototype._videoStarted = function() {
    if (this.hasAutoplay) {
      this.paused = true;
    }

    this.slideshowMain.addClass('slideshow--video-playing');
  };

  /**
   * Called when a video ends or is paused
   */
  Plugin.prototype._videoEnded = function() {
    if (this.hasAutoplay) {
      this.paused = false;
    }

    this.slideshowMain.removeClass('slideshow--video-playing');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

/**
 * Plugin to handle the main nav
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMainNav',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.mainNav = $(element);
    this.mainNavLinks = this.mainNav.find('.header__link');

    // Improve accessibility of menu by adding classes when an item is on focus
    this.mainNavLinks.on('focusin', function() {
      $(this).addClass('header__link--focused');
    });

    this.mainNavLinks.on('focusout', function() {
      $(this).removeClass('header__link--focused');
    });

    // Add a listener to check if the main nav can fit and init it (only when the logo is positioned in the center)
    if (!this.mainNav.hasClass('header__main-nav--stretched')) {
      this.mainNavWidth = Math.ceil(this.mainNav.width() + 35);
      this._verifyOverlap();

      $(window).on('resize.trademarkMainNav', $.proxy(this._verifyOverlap, this));
    }

    // We need to handle the overlap
    this.mainNav.find('.nav-dropdown--first').on('mouseenter', function() {
      var windowWidth = window.innerWidth,
        item = $(this),
        nestedMenus = item.find('.nav-dropdown--second'),
        rightEdge = this.getBoundingClientRect().right,
        shouldOpenLeft = false;

      nestedMenus.each(function(index, item) {
        if ((rightEdge + item.offsetWidth) > windowWidth) {
          shouldOpenLeft = true;
          return false; // this allows to break from the each
        }
      });

      if (shouldOpenLeft) {
        nestedMenus.addClass('nav-dropdown--left');
      } else {
        nestedMenus.removeClass('nav-dropdown--left');
      }
    });
  }

  Plugin.prototype.destroy = function() {
    this.mainNavLinks.off('focusin focusout');
    this.mainNav.removeData('plugin_trademarkMainNav');

    $(window).off('.trademarkMainNav');
  };

  Plugin.prototype._verifyOverlap = function() {
    // We need to find if the main nav overlap the logo. To find out this, we get the right edge of the main nav, and verify it's not "after" the left
    // position of the logo (the +35 is to add a bit more space)
    var isOverlapping = this.mainNavWidth > Math.ceil($('.header__logo').position().left - $('.header__inner').position().left);

    // If it's overlapping, we use the mobile navigation instead
    if (isOverlapping) {
      this.mainNav.hide();
      $('.header__nav-toggle').removeClass('hidden-desk');
    } else {
      this.mainNav.show();
      $('.header__nav-toggle').addClass('hidden-desk');
    }

    $('.header').addClass('header--init');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

/**
 * Plugin to handle the mini-cart
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMiniCart',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.miniCart = $(element);
    this.header = $('.header');
    this.headerCartCount = $('.header__cart-count');
    this.sidebarNav = $('.sidebar-nav');

    this.state = 'closed';

    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.body.on('click keypress', '[data-action="toggle-mini-cart"]', $.proxy(this._toggleMiniCart, this));
    this.miniCart.on('click', '[data-action="remove-line-item"]', $.proxy(this._removeLine, this));

    $(document).on('theme:cart:updated', $.proxy(this._cartUpdated, this));
    $(window).on('resize.trademarkMiniCart', $.proxy(this._computeMiniCartHeight, this));

    // We automatically re-render it a first time to solve a strange issue where adding a product in Ajax, going to Checkout and go back does not re-render
    // the very last version in Liquid
    this._rerender();

    if (Modernizr.csstransitions) {
      this.miniCart.on('transitionend', $.proxy(this._emitTransitionEvent, this));
    }
  }

  Plugin.prototype.destroy = function() {
    this.miniCart.removeData('plugin_trademarkMiniCart');
    this.miniCart.find('[data-action="remove-line-item"]').off('click');
    this.body.off('.trademarkMiniCart');

    $(document).off('theme:cart:updated');
    $(window).off('.trademarkMiniCart');
  };

  Plugin.prototype.getState = function() {
    return this.state;
  };

  Plugin.prototype._toggleMiniCart = function(event, addToCartClick) {
    var self = this;

    //close search form
    this.searchInstance = $('.header-search').data('plugin_trademarkHeaderSearch');
    this.searchInstance._closeSearch(event);

    // The mini-cart can be toggled using "Enter" key in keyboard as well
    if ((event.keyCode ? event.keyCode : event.which) == 13) {
      event.preventDefault(); // Prevent to follow the link
    }

    this._computeMiniCartHeight();

    if($(event.target).parents(".mini-cart-menu").length || addToCartClick == true){
    	this.miniCart.toggleClass('mini-cart--open');
    }

    if (this.miniCart.hasClass('mini-cart--open')) {
      // Before opening, we must check if the nav sidebar is open. If that's the case we first close it
      var sidebarNavInstance = this.sidebarNav.data('plugin_trademarkMobileSidebar');

      if (sidebarNavInstance.state === 'opening' || sidebarNavInstance.state === 'opened') {
        sidebarNavInstance._toggleSidebar(event);
      }

      this.state = 'opening';
      $(document).trigger('opening.trademarkMiniCart');

      this.body.addClass('no-scroll');
      this.pageOverlay.addClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'opened';
        $(document).trigger('opened.trademarkMiniCart');
      }

      this.miniCart.one('transitionend', function() {
        self.miniCart.focus(); // Allows to give focus for better accessibility on keyboard
      });

      this.body.on('keyup.trademarkMiniCart', function(outsideEvent) {
        if (outsideEvent.keyCode == 27) {
          self._toggleMiniCart(outsideEvent, false);
        }
      });

      this.body.on('click.trademarkMiniCart', function(outsideEvent) {
        if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
          self._toggleMiniCart(outsideEvent, false);
        }
      });
    } else {
      this.state = 'closing';
      $(document).trigger('closing.trademarkMiniCart');

      this.body.removeClass('no-scroll');
      this.body.off('.trademarkMiniCart');
      this.pageOverlay.removeClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'closed';
        $(document).trigger('closed.trademarkMiniCart');
      }
    }

    event.preventDefault();
  };

  Plugin.prototype._cartUpdated = function(event, cart, forceOpening, rerender) {
    this.headerCartCount.text(cart['item_count']);

    if (rerender || cart['item_count'] === 0) {
      this._rerender();
    } else {
      // If we do not completely re-render (for instance when we just delete a line), we just update the price
      this.miniCart.find('.mini-cart__total-price').replaceWith(
        '<span class="mini-cart-item__price mini-cart__total-price" data-money-convertible>' + Shopify.formatMoney(cart['total_price'], window.theme.moneyFormat) + '</span>'
      );
    }

    if (forceOpening) {
      this._toggleMiniCart(event,true);
    }
  };

  Plugin.prototype._removeLine = function(event) {
    var target = $(event.currentTarget),
      variantId = target.attr('data-variant-id'),
      lineItem = target.closest('.mini-cart__item-wrapper'),
      items = target.closest('.mini-cart__items');

    items.addClass('mini-cart__items--loading');

    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: 0,
        id: variantId
      }
    }).then(function(newCart) {
      items.removeClass('mini-cart__items--loading');
      lineItem.slideUp(250, function() {$(this).remove();});

      $(document).trigger('theme:cart:updated', [newCart, false, false]);
    });

    event.preventDefault();
  };

  /**
   * Rerender each items of the mini cart
   *
   * @param cart
   * @private
   */
  Plugin.prototype._rerender = function() {
    // We render the alternate mini-cart template instead of rendering it in JavaScript. This allows app vendor to hook their own logic within the
    // mini-cart in pure Liquid
    var self = this;
    const locale = window.theme.isDefaultLanguage ? '' : '/'.concat(window.theme.locale);

    $.ajax(locale + '/cart?view=mini-cart').then(function(result) {
      var domResult = $(result),
        miniCartCount = domResult.attr('data-cart-item-count');

      self.miniCart.find('.mini-cart__inner').replaceWith(domResult.find('.mini-cart__inner'));
      self.headerCartCount.text(miniCartCount);
      self._computeMiniCartHeight();

      self._updateMiniCartPrice();
    });
  };

  Plugin.prototype._updateMiniCartPrice = function() {
    var self = this;

    const miniCartItemsElm = this.miniCart.find('.mini-cart__items');
    const listProductIds = miniCartItemsElm.siblings('[data-list-product-ids]').val();

    if(!listProductIds) return;

    const productIdsArr = listProductIds.split(',').map((item) => {
      return parseInt(item);
    });

      GetPriceByListProductIds(productIdsArr, function(resultValue) {
        if(!resultValue) return;
  
        let totalPrice = 0;
  
        const listMiniCartItems = miniCartItemsElm.find('.mini-cart__item');
        
        listMiniCartItems.each(function(_, item) {
          const miniCartItemElm = $(item);
          const productItemId = miniCartItemElm.data('product-id').toString();
          const productItemData = resultValue.find(item => item.productid === productItemId);
          const linePrice = miniCartItemElm.find('.mini-cart-item__line-price').data('line-price');
          
          if (!productItemData) {
            totalPrice += linePrice;
          } 
          else {
            const variantId = miniCartItemElm.data('variant-id').toString();
            const variantData = productItemData.variant.find(v => v.id === variantId);
    
            if (!variantData) {
              totalPrice += linePrice;
            }
            else {
              const partnerOrginalPrice = variantData.price;
      
              if(!partnerOrginalPrice) {
                totalPrice += linePrice;
              }
              else {
                const price = miniCartItemElm.data('price');
        
                // update price
                const linePriceAfterUpdate = updateMiniCartItemPrice(price, partnerOrginalPrice * 100, miniCartItemElm);
  
                totalPrice += linePriceAfterUpdate;
              };
            };
          };
  
        });
  
        // update total price at here
        self.miniCart.find('.mini-cart__total-price').html(Shopify.formatMoney(totalPrice, window.theme.moneyFormat));
      });


    function updateMiniCartItemPrice(price, partnerPrice, cartItemElm) {
      const newPrice = Math.min(price, partnerPrice);
      const qty = cartItemElm.find('.minicart-qty').data('qty');
      const linePrice = newPrice * qty;

      if(price === newPrice) return linePrice;

      cartItemElm.find('.mini-cart-item__line-price').html(Shopify.formatMoney(linePrice, window.theme.moneyFormat));

      return linePrice;
    };
  }

  /**
   * Compute the correct mini-cart height (by taking into account things such as top bar, viewport...)
   */
  Plugin.prototype._computeMiniCartHeight = function() {
    // First, we need to get how much of the "top bar" (which is not fixed) is visible in the viewport
    var headerOuterHeight = this.header.outerHeight();

    this.miniCart.find('.mini-cart__inner').css('max-height', (window.innerHeight - headerOuterHeight) + 'px');
  };

  /**
   * Callback called whenever the transition (animation of opening or closing) is ended so we can emit events for other parts of the system
   */
  Plugin.prototype._emitTransitionEvent = function(event) {
    if (event.originalEvent.propertyName !== 'transform') {
      return;
    }

    if (this.state === 'opening' || this.state === 'opened') {
      this.state = 'opened';
      $(document).trigger('opened.trademarkMiniCart');
    } else {
      this.state = 'closed';
      $(document).trigger('closed.trademarkMiniCart');
    }
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle the mobile sidebar
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMobileSidebar',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.sidebarNav = $(element);
    this.header = $('.header');
    this.headerNavToggle = this.header.find('[data-action="toggle-mobile-sidebar"]');
    this.miniCart = $('.mini-cart');

    this.state = 'closed';

    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.headerNavToggle.on('click.trademarkMobileSidebar', $.proxy(this._toggleSidebar, this));
    this.sidebarNav.find('[data-action="toggle-mobile-sub-menu"]').on('click.trademarkMobileSidebar', $.proxy(this._toggleSubMenu, this));

    $(window).on('resize.trademarkMobileSidebar', $.proxy(this._computeSidebarHeight, this));

    if (Modernizr.csstransitions) {
      this.sidebarNav.on('transitionend', $.proxy(this._emitTransitionEvent, this));
    }
  }

  Plugin.prototype.destroy = function() {
    this.header.find('[data-action="toggle-mobile-sidebar"]').off('click');
    this.sidebarNav.find('[data-action="toggle-mobile-sub-menu"]').off('click');
    this.body.off('.trademarkMobileSidebar');
    $(window).off('.trademarkMobileSidebar');

    this.sidebarNav.removeData('plugin_trademarkMobileSidebar');
  };

  Plugin.prototype.getState = function() {
    return this.state;
  };

  /**
   * Tgogle the navigation sidebar
   */
  Plugin.prototype._toggleSidebar = function(event) {
    var self = this;

    this.headerNavToggle.toggleClass('header__nav-toggle--open');

    this._computeSidebarHeight();
    this.sidebarNav.toggleClass('sidebar-nav--open');

    if (this.sidebarNav.hasClass('sidebar-nav--open')) {
      // Before opening, we must check if the mini-cart is open. If that's the case we first close it
      var miniCartInstance = this.miniCart.data('plugin_trademarkMiniCart');

      if (undefined !== miniCartInstance && (miniCartInstance.state === 'opening' || miniCartInstance.state === 'opened')) {
        miniCartInstance._toggleMiniCart(event, false);
      }

      this.state = 'opening';
      $(document).trigger('opening.trademarkMobileSidebar');

      this.body.addClass('no-scroll');
      this.pageOverlay.addClass('page__overlay--open');

      this.body.on('click.trademarkMobileSidebar', function(outsideEvent) {
        if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
          self._toggleSidebar(outsideEvent);
        }
      });

      if (!Modernizr.csstransitions) {
        this.state = 'opened';
        $(document).trigger('opened.trademarkMobileSidebar');
      }
    } else {
      this.state = 'closing';
      $(document).trigger('closing.trademarkMobileSidebar');

      this.body.removeClass('no-scroll');
      this.body.off('.trademarkMobileSidebar');
      this.pageOverlay.removeClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'closed';
        $(document).trigger('closed.trademarkMobileSidebar');
      }
    }

    event.preventDefault();
  };

  /**
   * Toggle a submenu
   */
  Plugin.prototype._toggleSubMenu = function(event) {
    var buttonContainer = $(event.target),
      sidebarMenu = buttonContainer.closest('li').find('> .sidebar-nav__sub-links');
    sidebarMenu.parent().find("> a").toggleClass("open");
    buttonContainer.attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'})
      .find('.plus-button').toggleClass('plus-button--active');
    sidebarMenu.slideToggle();
    event.preventDefault();
  };

  /**
   * Compute the correct sidebar height (by taking into account things such as top bar, viewport...)
   */
  Plugin.prototype._computeSidebarHeight = function() {
    // First, we need to get how much of the "top bar" (which is not fixed) is visible in the viewport
    var headerOuterHeight = this.header.outerHeight();

    this.sidebarNav.css('max-height', (window.innerHeight - headerOuterHeight) + 'px');

  };

  /**
   * Callback called whenever the transition (animation of opening or closing) is ended so we can emit events for other parts of the system
   */
  Plugin.prototype._emitTransitionEvent = function(event) {
    if (event.originalEvent.propertyName !== 'transform') {
      return;
    }

    this._cursorFocus(this.sidebarNav); // Give the focus to the sidebar for easier keyboard navigation

    if (this.state === 'opening' || this.state === 'opened') {
      this.state = 'opened';
      $(document).trigger('opened.trademarkMobileSidebar');
    } else {
      this.state = 'closed';
      $(document).trigger('closed.trademarkMobileSidebar');
    }
  };

  /**
   * Allow to give focus on an item while preserving scroll position
   */
  Plugin.prototype._cursorFocus = function(element) {
    var x = window.scrollX,
      y = window.scrollY;

    element.focus();
    window.scrollTo(x, y);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle product update
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkProduct',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {Object} options
   */
  function Plugin(element, options) {
    this.element = $(element);
    this._init(options);
  }

  Plugin.prototype._init = function(options) {
    this.product = options['product'];
    this.enableHistoryState = options['enableHistoryState'];
    this.optionsWithValues = options['optionsWithValues'];
    this.allowSelectingSoldOutVariants = options['allowSelectingSoldOutVariants'];
    this.context = options['context'] || null;
    this.singleOptionSelectors = this.element.find('.single-option-selector');
    this.dataSelectors = this.element.find('[data-selector-type]').toArray();
    this.masterSelector = this.element.find('#product-select-' + options['product']['id']);
    this.productSlides = this.element.find('.product__slides');
    this.productPrices = this.element.find('.product__prices');
    this.addToCartButton = this.element.find('.product__add-to-cart');
    this.quantitySelector = this.element.find('.quantity-selector');

    this.currentVariant = this._getVariantFromOptions();

    this.singleOptionSelectors.on('change', $.proxy(this._onSelectorChanged, this)).trigger('change');
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').on('click', $.proxy(this._decreaseProductQuantity, this));
    this.quantitySelector.find('[data-action="increase-product-quantity"]').on('click', $.proxy(this._increaseProductQuantity, this));

    // In order to improve accessibility in keyboard, we allow to update swatches when pressing the Enter key over a label
    this.singleOptionSelectors.next('label').on('keypress', function(e) {
      if ((e.keyCode ? e.keyCode : e.which) == 13) {
        $(this).trigger('click');
      }
    });

    // If Ajax cart is enabled we add some more listeners to add product in the background
    if(options["rv_add_to_card"] == true){
    	this._addToCart();
    }

      this.addToCartButton.on('click', $.proxy(this._addToCart, this));

  };

  Plugin.prototype.destroy = function() {
    this.singleOptionSelectors.off('change');
    this.singleOptionSelectors.next('label').off('keypress');
    this.addToCartButton.off('click');
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').off('click');
    this.quantitySelector.find('[data-action="increase-product-quantity"]').off('click');

    this.element.removeData('plugin_trademarkProduct');
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE PRODUCT OPERATIONS
   * ---------------------------------------------------------------------------------------------------
   */

  Plugin.prototype._decreaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.text());

    // Do nothing if it's already one...
    if (currentQuantityAsNumber === 1) {
      event.preventDefault();
      return;
    }

    var newQuantity = currentQuantityAsNumber - 1;

    currentQuantity.text(newQuantity);

    this.element.find('[name="quantity"]').val(newQuantity);

    event.preventDefault();
  };

  Plugin.prototype._increaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.text()),
      newQuantity = currentQuantityAsNumber + 1;

    currentQuantity.text(newQuantity);

    this.element.find('[name="quantity"]').val(newQuantity);

    event.preventDefault();
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * Whenever the variant changes, we have several things to update: the slideshow image, the prices,
   * the labels...
   */
  Plugin.prototype._onVariantChanged = function(previousVariant, newVariant) {

    // 1st: the slideshow
    this._updateSlideshowImage(previousVariant, newVariant);

    // 2st: the prices
    this._updateProductPrices(previousVariant, newVariant);

    // 3rd: update the variant dropdowns
    this._updateSelectors(previousVariant, newVariant);

    // 4th: the add to cart button
    this._updateAddToCartButton(previousVariant, newVariant);

    // 5th: Update product tabs 
    var productId = this.product.id;
    // Desktop
    $(".gwt__tab").removeClass("gwt__tab--active");
    $("#gwt_" + window.theme.locale.toUpperCase() + "_" + productId + "_" + newVariant.id).addClass("gwt__tab--active");

    // Mobile
    $(".gwt__tab-m").removeClass("gwt__tab-m--active");
    $("#gwt_" + window.theme.locale.toUpperCase() + "_" + productId + "_" + newVariant.id + "-m").addClass("gwt__tab-m--active");

    $("#sony-new-variant").val(newVariant.id);
    $("#sony-new-variant").attr("data-price", newVariant['price']);
  };

  /**
   * Switch to the correct slideshow image
   */
  Plugin.prototype._updateSlideshowImage = function(previousVariant, newVariant) {
    if (!newVariant || !newVariant['featured_media']) {
      return;
    }

    if (this.productSlides.length > 0) {
      this.productSlides.slick(
        'slickGoTo',
        parseInt(this.productSlides.find('[data-image-id="' + newVariant['featured_media']['id'] + '"]').attr('data-image-position'))
      );
    }

    if (this.context === 'homepage') {
      this.element.find('.product__featured-image[data-image-id="' + newVariant['featured_image']['id'] + '"]').show()
        .siblings().hide();
    }
  };

  /**
   * Update the prices. If the variant does not exist, we hide the prices completely
   */
  Plugin.prototype._updateProductPrices = function(previousVariant, newVariant) {

    if (!newVariant) {

      this.productPrices.each(function(index, element) {
        var parent = $(element).parent();

        if (parent.hasClass('form__control')) {
          parent.hide();
        } else {
          $(element).hide();
        }
      });
    } else {

      if (previousVariant && (previousVariant['price'] === newVariant['price']) && (previousVariant['compare_at_price'] === newVariant['compare_at_price'])) {
        return;
      }

      this.productPrices.empty();

      if (newVariant['compare_at_price'] > newVariant['price']) {
        var discount = Math.floor((1- ( newVariant['price']/newVariant['compare_at_price']))*100);
       	$(".template-product .product__slideshow .discount").show();
        $(".template-product .product__slideshow .discount .price-save").html(discount+"%");
        this.productPrices.append('<span id="mw-current-variant" class="product__price product__price--new h4" data-id="'+ newVariant['id'] +'" data-price="'+ newVariant['price'] +'" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>');
        this.productPrices.append('<span class="product__price product__price--old h4" data-money-convertible>' + Shopify.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>');
      	if($(".template-product .label.label--on-sale").length){
        	$(".template-product .label.label--on-sale").show();
        }
        else {
        	$('.flex-box.product-box').insertAfter('<div class="product-item__labels labels"><span class="label label--on-sale">On Sale</span> </div>');
        }
      } else {
        $(".template-product .product__slideshow .discount").hide();
        $(".template-product .label.label--on-sale").hide();
        this.productPrices.append('<span id="mw-current-variant" class="product__price h4" data-id="'+ newVariant['id'] +'" data-price="'+ newVariant['price'] +'" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>');
      }
      this.productPrices.show().parent().show();


    }


  };

  /**
   * Update the selectors
   *
   * We have different kind of selectors: the size one, the color swatch and standard dropdown. When a new variant is selected, we must check the options
   * and prevent selection of unavailable and, if selected by the merchant, sold out variants
   */
  Plugin.prototype._updateSelectors = function(previousVariant, newVariant) {
    // No need to recompute the combinations if there is only one option
    if (!newVariant || this.product['options'].length <= 1) {
      return;
    }

    var option1 = newVariant['option1'],
      option2 = newVariant['option2'],
      option3 = newVariant['option3'],
      variantsCount = this.product['variants'].length;

    for (var i = 0 ; i != this.dataSelectors.length ; ++i) {
      var dataSelector = $(this.dataSelectors[i]),
        dataSelectorType = dataSelector.attr('data-selector-type'),
        optionIndex = (i + 1),
        optionValues = this.optionsWithValues[i]['values'];

      for (var j = 0 ; j != optionValues.length ; ++j) {
        var valueToCheck = optionValues[j],
          variantExists = false,
          allowVariantSelection = false,
          variantAvailable = false,
          variantPrice0 = false;

        if (optionIndex === 1) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === valueToCheck && currentVariant['option2'] === option2 && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];
              variantPrice0 = currentVariant.price === 0;

              break;
            }
          }
        } else if (optionIndex === 2) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === valueToCheck && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];
              variantPrice0 = currentVariant.price === 0;

              break;
            }
          }
        } else if (optionIndex === 3) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === option2 && currentVariant['option3'] === valueToCheck) {
              variantExists = true;
              variantAvailable = currentVariant['available'];
              variantPrice0 = currentVariant.price === 0;

              break;
            }
          }
        }

        if (variantExists && !variantPrice0) {
          if (variantAvailable || this.allowSelectingSoldOutVariants) {
            allowVariantSelection = true;
          }
        } else {
          allowVariantSelection = false;
        }

        if (dataSelectorType === 'size') {
          // For the size, we need to add the "product__size--unavailable" class and "disabled" to the input
          var sizeItem = dataSelector.find('.product__size').eq(j);

          if (allowVariantSelection) {
            sizeItem.removeClass('product__size--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            sizeItem.addClass('product__size--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }
        } else if (dataSelectorType === 'color') {
          // For the color, we need to add the "product__color--unavailable" class and "disabled" to the input
          var colorItem = dataSelector.find('.product__color').eq(j);

          if (allowVariantSelection) {
            colorItem.removeClass('product__color--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            colorItem.addClass('product__color--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }
        } else if (dataSelectorType === 'select') {
          // For the select, we need to add disabled to the option
          var optionItem = dataSelector.find('option').eq(j);

          if (allowVariantSelection) {
            optionItem.removeAttr('disabled');
          } else {
            optionItem.attr('disabled', 'disabled');
          }
        }
      }
    }

  };

  /**
   * Update the add to cart button
   */
  Plugin.prototype._updateAddToCartButton = function(previousVariant, newVariant) {
    // Check if we have payment button
    var smartPaymentButton = this.element.find('.shopify-payment-button');

    if (!newVariant) {
      this.addToCartButton.attr('disabled', 'disabled')
        .removeClass('button--primary')
        .addClass('button--secondary')
        .text(window.languages.productFormUnavailable);

      smartPaymentButton.hide();
    } else {
      if (newVariant['available']) {
        this.addToCartButton.removeAttr('disabled')
          .addClass('button--primary')
          .removeClass('button--secondary sold-out')
          .text(window.languages.productFormAddToCart);

        smartPaymentButton.show();
      } else {
        this.addToCartButton.attr('disabled', 'disabled')
          .removeClass('button--primary')
          .addClass('button--secondary sold-out')
          .text(window.languages.productFormSoldOut);

        smartPaymentButton.hide();
      }
    }
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE VARIANT CHANGES
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * This call back is called whenever a property in one of the select or radio button has changed
   */
  Plugin.prototype._onSelectorChanged = function() {
    var previousVariant = this.currentVariant;

    this.currentVariant = this._getVariantFromOptions();
    this._onVariantChanged(previousVariant, this.currentVariant);

    // Update Wishlist
    this.element.find(".add-to-wishlist").data("variant-id", this.currentVariant.id);
    const wishlistCollections = this.element.find(".wishlist_collections");

    wishlistCollections.each((_, w) => {
      const self = $(w);
      const varArr = self.siblings('.input_variants').attr('data_variants');

      if(varArr) {
        var wishlistArray = varArr != null ? varArr.split(",") : "";

        const variantId = self.data('variant-id').toString();
    
        if ($.inArray(variantId, wishlistArray) !== -1) {
          self.addClass("btn-active")
              .attr("title","Remove Wishlist");
        }
        else{
          self.removeClass("btn-active")
              .attr("title","Add Wishlist");
        };
      }
    });

    if (this.currentVariant) {
      if (this.enableHistoryState) {
        this._updateHistoryState(this.currentVariant);
      }

      // We need to modify the hidden select that contain the id attribute as well
      this.masterSelector.find('[selected]').removeAttr('selected');
      this.masterSelector.find('[value="' + this.currentVariant['id'] + '"]').prop('selected', true);
    }

    // We also trigger an event so that other system can hookup and perform additional changes
    $(document).trigger('variant_changed.product', this.currentVariant);
  };

  /**
   * Update the HTML history state
   */
  Plugin.prototype._updateHistoryState = function(variant) {
    if (!history.replaceState) {
      return;
    }

    const objParams = Object.fromEntries(new URLSearchParams(window.location.search));
    objParams.variant = variant.id;

    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + $.param(objParams);

    window.history.replaceState({path: newUrl}, '', newUrl);
  };

  /**
   * Get the variant that is currently selected
   */
  Plugin.prototype._getVariantFromOptions = function() {
    var selectedValues = this._getCurrentOptions();
    var variants = this.product['variants'];
    var found = false;

    variants.forEach(function(variant) {
      var satisfied = true;

      selectedValues.forEach(function(option) {
        if (satisfied) {
          satisfied = (option.value === variant[option.index]);
        }
      });

      if (satisfied) {
        found = variant;
      }
    });

    return found || null;
  };

  /**
   * Extract all the current options
   */
  Plugin.prototype._getCurrentOptions = function() {
    var currentOptions = this.singleOptionSelectors.toArray().map(function(element) {
      var $element = $(element),
        type = $element.attr('type'),
        index = $element.attr('data-option-index');

      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          return {value: $element.val(), index: index};
        } else {
          return false;
        }
      } else {
        return {value: $element.val() || $element.find('option:selected').val(), index: index};
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes

    return currentOptions.filter(function(item) {
      return item;
    });
  };

  /**
   * Handle cart ajax error
   */
   Plugin.prototype._handleCartAjaxError = function() {
    // If there is an error while adding (usually if all products are added to the cart), we temporarily
    // display the message from Shopify, and then revert to the original message after 2 seconds
    // var errorMessage = error.responseJSON['description'];
    var self = this;
    var errorMessage = window.languages.sold_out_message;
    var addToCartVariant = this.addToCartButton.find("> span").text();

    this.addToCartButton.text(errorMessage)
      .removeAttr('disabled')
      .removeClass('button--loading');
    this.addToCartButton.attr("old-text", addToCartVariant);

    setTimeout(function() {
      self.addToCartButton.text(window.languages.productFormAddToCart);
      var attr = self.addToCartButton.attr('old-text');

      if (typeof attr !== typeof undefined && attr !== "") {
        // Element has this attribute
        self.addToCartButton.append("<span>" + attr + "</span>");
      }
    }, 2500);
  };

  /**
   * Handle cart ajax success
  */
  Plugin.prototype._handleCartAjaxSuccess = function(cart) {
    this.addToCartButton.removeAttr('disabled').removeClass('button--loading');
    $(document).trigger('theme:cart:updated', [cart, true, true]);
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
   * ---------------------------------------------------------------------------------------------------
   */

  Plugin.prototype._addToCart = function(event) {
    var self = this;
    // First, we switch the status of the button to display the spinner
    this.addToCartButton.attr('disabled', 'disabled').addClass('button--loading');
    // Then we add the product in Ajax

    const cartForm = self.element.find('form[action*="/cart/add"]');
    const variantId = parseInt(cartForm.find('[name=id]').val());
    const newPrice = cartForm.find('[name=id]').data('new-price') || cartForm.closest('.product-content-bottom').data('new-price');
    const qty = parseInt(cartForm.find('input[name=quantity]').val());

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const newCartItems = cart.items
        .filter(ele => ele.properties['_new_line_price'] && ele.properties['_new_line_price'] != 'NaN')
        .map(item => ({
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          title: item.product_title
        }));

      const existedItem = newCartItems.find(itm => itm?.variant_id === variantId);
      const line = newCartItems.findIndex(itm => itm?.variant_id === variantId);

      const newItems = { variant_id: variantId, quantity: qty, product_id: self.product.id, title: self.product.title };

      if (existedItem) {
        existedItem.quantity += qty;
      } else {
        if (newPrice) {
          newCartItems.push(newItems);
        }
      }

        getValidatePartnerQuota(newCartItems, function(result) {
          if (result && result.validTotalQuota.toLowerCase() === "false") {
            alert('The total/yearly quota has exceeded.');
            self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
            return;
          }
          
          if(result) {
            let strError = '';
            const arrayInValidVariantIds = JSON.parse(result.inValidVariantIds.replace(',]', ']'));
    
            if (arrayInValidVariantIds && arrayInValidVariantIds.length > 0) {
              arrayInValidVariantIds.forEach(element => {
                const dataItem = newCartItems.find(item => item.variant_id == element);
    
                if (dataItem) {
                  strError += 'The product "' + dataItem.title + '" has exceeded category quota.\n';
                }
              });
    
              if (strError.length > 0) {
                alert(strError);
                self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
                return;
              }
            }
          }
  
          if (existedItem) {
            const data = {
              quantity: existedItem.quantity,
              properties: {
                '_new_line_price': newPrice * existedItem.quantity
              }
            };
  
            if (line >= 0) {
              data.line = line + 1;
            } else {
              data.id = existedItem.variant_id
            }
  
            $.ajax({
              method: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: data
            })
            .then((changedCart) => {
              self._handleCartAjaxSuccess(changedCart);
            })
            .catch(() => self._handleCartAjaxError())
          } 
          else {
            const data = {
              quantity: qty,
              id: variantId,
              properties: {
                '_new_line_price': newPrice * qty
              }
            }
  
            $.ajax({
              method: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data
            })
            .then((newCartItem) => {
              var newCart = {
                ...cart,
                items: [
                  ...cart.items,
                  newCartItem
                ]
              }
              self._handleCartAjaxSuccess(newCart)
            })
            .catch(() => self._handleCartAjaxError())
          }  
        });

    });

    if(event != undefined) {
    	event.preventDefault();
    }
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle tabs
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkTabs',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.navItems = this.element.find('.tabs__nav-item');
    this.content = this.element.find('.tabs__content');
    this.contentItems = this.content.find('.tabs__content-item');

    this.navItems.on('click', $.proxy(this._changeTab, this));

    var tabsNav = this.element.find('.tabs__nav-inner'),
      tabsNavElem = tabsNav.get(0);

    tabsNavElem.classList[tabsNavElem.scrollWidth - tabsNavElem.clientWidth - tabsNavElem.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-right');

    tabsNav.on('scroll', function() {
      this.classList[this.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-left');
      this.classList[this.scrollWidth - this.clientWidth - this.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-right');
    });
  }

  Plugin.prototype.destroy = function() {
    this.navItems.off('click');

    this.element.removeData('plugin_trademarkTabs');
  };

  Plugin.prototype._changeTab = function(event) {
    var target = $(event.target),
      currentItem = this.contentItems.filter('.tabs__content-item--active'),
      newItem = this.contentItems.eq(target.index()),
      self = this;

    // Set the current height to the container, so that animation can be done
    this.content.css('height', currentItem.height());

    // Change the active nav item
    target.siblings().removeClass('tabs__nav-item--active').end().addClass('tabs__nav-item--active');

    currentItem.removeClass('tabs__content-item--active');
    newItem.addClass('tabs__content-item--active');

    // Set the height of the new item for the parent to trigger CSS3 animation
    this.content.css('height', newItem.height());

    // Then, make sure to remove the hard-coded height to allow change in height inside the container
    if (Modernizr.cssanimations) {
      this.content.one('webkitAnimationEnd animationend', function() {
        self.content.css('height', '');
      });
    } else {
      this.content.css('height', '');
    }

    event.preventDefault();
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));


var router = new RouterRouter();
var locale = window.theme.isDefaultLanguage ? '' : window.theme.locale?.concat('/');

router.route('*all', function() {
  var bodyElement = $('body');

  /**
   * -------------------------
   * STICKY HEADER POLYFILL AND HEADER SIZE
   * -------------------------
   */

  (function() {
    var headerSection = $('.shopify-section__header');

    Stickyfill.add(headerSection.get(0));
    $('.anchor').css('top', -headerSection.height());

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      Stickyfill.remove(event.target);
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      Stickyfill.add(event.target);
    });
  }());

  /**
   * -------------------------
   * MOBILE/TABLET NAVIGATION
   * -------------------------
   */

  (function() {
    $('.sidebar-nav').trademarkMobileSidebar();

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      $(event.target).find('.sidebar-nav').data('plugin_trademarkMobileSidebar').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      $(event.target).find('.sidebar-nav').trademarkMobileSidebar();
    });
  }());

  /**
   * -------------------------
   * MAIN NAVIGATION (ACCESSIBILITY)
   * -------------------------
   */

  (function() {
    $('.header__main-nav').trademarkMainNav();

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      $(event.target).find('.header__main-nav').data('plugin_trademarkMainNav').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      $(event.target).find('.header__main-nav').trademarkMainNav();
    });
  }());

  /**
   * -------------------------
   * MINI-CART
   * -------------------------
   */

  (function() {
      $('.mini-cart').trademarkMiniCart();

      $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
        $(event.target).find('.mini-cart').data('plugin_trademarkMiniCart').destroy();
      });

      $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
        $(event.target).find('.mini-cart').trademarkMiniCart();
      });

  }());

  /**
   * -------------------------
   * SEARCH
   * Note that search initialization must happen after mini-cart and sidebar, as it relies on the existence of those two
   * -------------------------
   */

  (function() {
    $('.header-search').trademarkHeaderSearch();

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      $(event.target).find('.header-search').data('plugin_trademarkHeaderSearch').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      $(event.target).find('.header-search').trademarkHeaderSearch();
    });
  }());

  /**
   * -------------------------
   * RTE (FOR PAGE THAT CONTAINED USER DEFINED TEXT, WE DO SOME POST-PROCESSING
   * -------------------------
   */

  (function() {
    // 1st: wrap tables
    $('.rte table').addClass('table').wrap('<div class="table-wrapper"></div>');

    // 2nd: wrap videos
    var iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var iframeReset = iframeVideo.add('.rte iframe#admin_bar_iframe');

    iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }());

  /**
   * -------------------------
   * FEATURED COLLECTIONS
   * -------------------------
   */

  (function() {
    if (!Modernizr.touchevents || Modernizr.mq('(min-width: 1024px)')) {
      bodyElement.on('mouseenter mouseleave', '.collection-item', function() {
        $(this).toggleClass('collection-item--hovered').find('.collection-item__bottom').slideToggle({duration: 250});
      });
    }
  }());

  /**
   * ----------------------------
   * FEATURED MAP
   * ----------------------------
   */

  (function() {
    $('.featured-map').trademarkMap();

    $(document).on('shopify:section:load', '.shopify-section__featured-map', function(event) {
      $(event.target).find('.featured-map').trademarkMap();
    });

    $(document).on('shopify:section:unload', '.shopify-section__featured-map', function(event) {
      $(event.target).find('.featured-map').data('plugin_trademarkMap').destroy();
    });
  }());

  /**
   * -------------------------
   * TWITTER
   * -------------------------
   */

  (function() {
    var initTwitter = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      window.twttr = (function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {}; if (d.getElementById(id)) return t; js = d.createElement(s);
        js.id = id; js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs); t._e = []; t.ready = function(f) {t._e.push(f);};
        return t;
      }(document, "script", "twitter-wjs"));

      var twitterHandle = domElement.attr('data-twitter-handle');

      twttr.ready(function () {
        twttr.widgets.createTimeline(
          {
            sourceType: 'profile',
            screenName: twitterHandle
          },
          document.getElementById('twitter-timeline'),
          {
            tweetLimit: 1,
            lang: window.theme.locale || 'en',
            chrome: 'noheader nofooter noborders transparent noscrollbar'
          }
        ).then(function (result) {
          // Twitter return the results in an iframe, so we need to parse the code to extract what we want

          var content = $(result).contents(),
            twitterModule = $('.tweet');

          twitterModule.find('.tweet__content').html(content.find('.timeline-Tweet-text'));
          twitterModule.find('.tweet__date').text(content.find('.timeline-Tweet-timestamp .dt-updated').attr('aria-label'));
        });
      });
    };

    initTwitter($('.footer [data-twitter-handle]'));

    $(document).on('shopify:section:load', '#shopify-section-footer', function(event) {
      initTwitter($(event.target).find('[data-twitter-handle]'));
    });
  }());

  /**
   * -------------------------
   * Products Slider - Featured Products
   * -------------------------
   */

   (function() {
    var initProducts = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        mobileFirst: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        accessibility: false,
        useCSS: true,
        prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
        nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
        responsive: [
          {
            breakpoint: 320,
            settings: 'unslick'
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      })
    };

    initProducts($('[data-slick-slider]'));

    $(document).on('shopify:section:unload', '.shopify-section__slider-section', function(event) {
      $(event.target).find('[data-slick-slider]').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__slider-section', function(event) {
      initProducts($(event.target).find('[data-slick-slider]'));
    });

    var winWidth = $(window).innerWidth();
    var resizeTimerId;

    $(window).on('resize orientationChange', function() {
      clearTimeout(resizeTimerId);

      resizeTimerId = setTimeout(function() {
        var curWinWidth = $(window).innerWidth();

        if (curWinWidth < 320 && winWidth >= 320) {
          initProducts($('[data-slick-slider]'));
        }
        else if(curWinWidth >= 768 && winWidth < 768) {
          initProducts($('[data-slick-slider]'));
        }

        winWidth = curWinWidth;
      }, 200);
    });
  }());
});

router.route(locale?.concat('blogs/*blog/*article'), function() {
  /**
     * -------------------------
     * STICKY SHARE BUTTONS
     * -------------------------
     */

  (function() {
    var header = $('#shopify-section-header'),
        shareButtons = $('.article__body .share-buttons');

    shareButtons.css('top', header.height() + 20);
    shareButtons.Stickyfill();
  }());
});

router.route(locale?.concat('blogs/*blog'), function() {
});

router.route(locale?.concat('cart'), function() {
  /**
     * -------------------------
     * SHIPPING ESTIMATOR
     * -------------------------
     */

  (function() {
    var initShippingEstimator = function() {
      var shippingEstimator = $('.shipping-estimator');

      // If the estimator has been disabled, we do not need to attach all the other listeners
      if (shippingEstimator.length === 0) {
        return;
      }

      var shippingEstimatorForm = shippingEstimator.find('.shipping-estimator__form'),
          shippingEstimatorSubmit = shippingEstimator.find('.shipping-estimator__submit'),
          shippingEstimatorResults = shippingEstimator.find('.shipping-estimator__results'),
          shippingEstimatorList = shippingEstimatorResults.find('.shipping-estimator__list'),
          cartEstimatedShipping = $('.cart__shipping');

      $('.shipping-estimator--mobile .shipping-estimator__title').on('click', function() {
        $(this).next('.shipping-estimator__inner').slideToggle();
        $(this).closest('.shipping-estimator').toggleClass('shipping-estimator--active');
      });

      var submitShippingEstimatorForm = function(event) {
        shippingEstimatorSubmit.text(window.languages.shippingEstimatorSubmitting);

        $.ajax({
          method: 'GET',
          url: '/cart/shipping_rates.json',
          data: $(event.currentTarget).closest('.shipping-estimator__form').find('input, select').serialize(),
          success: function(results) {
            shippingEstimatorList.empty();

            results['shipping_rates'].forEach(function(item) {
              var amount = Shopify.formatMoney(item['price'] * 100, window.theme.moneyFormat);
              shippingEstimatorList.append('<li class="shipping-estimator__item">' + item['name'] + ': <span data-money-convertible>' + amount + '</span></li>');
            });

            if (results['shipping_rates'].length > 0) {
              var firstPrice = Shopify.formatMoney(results['shipping_rates'][0]['price'] * 100, window.theme.moneyFormat);
              cartEstimatedShipping.html(window.languages.cartEstimatedShipping + ' ' + firstPrice);
            }
          },
          error: function(results) {
            shippingEstimatorList.empty();

            var response = results.responseJSON,
                errors = [];

            for (var key in response) {
              if (response.hasOwnProperty(key)) {
                errors.push({key: key, value: response[key][0]});
              }
            }

            errors.forEach(function(item) {
              shippingEstimatorList.append('<li class="shipping-estimator__item">' + item['key'] + ': ' + item['value'] + '</li>');
            });
          },
          complete: function(results) {
            shippingEstimatorSubmit.html(window.languages.shippingEstimatorSubmit);
            shippingEstimatorResults.show();
          }
        });

        event.preventDefault();
      };

      shippingEstimatorForm.on('keypress', function(event) {
        // If Enter is press, we submit the form
        if (event.keyCode == 13) {
          submitShippingEstimatorForm(event);
        }
      });

      $('.shipping-estimator__submit').on('click', function(event) {
        submitShippingEstimatorForm(event);
      });

      new Shopify.CountryProvinceSelector('address_country', 'address_province', {hideElement: 'address_province_container'});
      new Shopify.CountryProvinceSelector('address_country_mobile', 'address_province_mobile', {hideElement: 'address_province_container_mobile'});
    };

    initShippingEstimator();

    $(document).on('shopify:section:load', '#shopify-section-cart-template', function() {
      initShippingEstimator();
    });
  }());

  /**
     * -------------------------
     * GET PRICE FOR CART ITEMS
     * -------------------------
     */
  (function() {
    function getPriceForCartItems() {    
      const elm = $('[data-actions="getPriceForCartItems"]');
      const listProductIds = elm.siblings('[data-list-product-ids]').val();

      if(!listProductIds) return;
  
      const productIdsArr = listProductIds.split(',').map((item) => {
        return parseInt(item);
      });

      $('#cover-spin').addClass('active');

        GetPriceByListProductIds(productIdsArr, function(resultValue) {
          if(resultValue) {
            let totalPrice = 0;
    
            const listCartItems = elm.find('.cart-item');
            
            listCartItems.each(function(idx, item) {
              const cartItemElm = $(item);
              const productItemId = cartItemElm.data('product-id').toString();
              const productItemData = resultValue.find(item => item.productid === productItemId);
              const linePrice = cartItemElm.find('.cart-item__line-price').data('line-price');
              
              if (!productItemData) {
                totalPrice += linePrice;
              } 
              else {
                const variantId = cartItemElm.data('variant-id').toString();
                const variantData = productItemData.variant.find(v => v.id === variantId);
        
                if (!variantData) {
                  totalPrice += linePrice;
                }
                else {
                  const partnerOrginalPrice = variantData.price;
          
                  if(!partnerOrginalPrice) {
                    totalPrice += linePrice;
                  }
                  else {
                    const price = cartItemElm.data('price');
            
                    // update price
                    const linePriceAfterUpdate = updateCartItemPrice(price, partnerOrginalPrice * 100, cartItemElm, idx);
      
                    totalPrice += linePriceAfterUpdate;
                  };
                };
              };
      
            });
      
            // update total price at here
            $('.cart__footer .cart__subtotal').html(Shopify.formatMoney(totalPrice, window.theme.moneyFormat));
  
            $('#cover-spin').removeClass('active');
  
            return;
          }
  
          $('#cover-spin').removeClass('active');
        });


      updatePartnerCodeToCart($('#customer-infor').data('partner-code'));
     
    }

    function updatePartnerCodeToCart(partnerCode) {
      $.ajax({
          method: 'POST',
          url: '/cart/update.js',
          data: {
            "attributes[partner_code]": partnerCode
          },
          dataType: 'json'
      });
    }

    function updateCartItemPrice(price, partnerPrice, cartItemElm, idx) {
      const newPrice = Math.min(price, partnerPrice);
      const qty = cartItemElm.find('.quantity-selector__current-quantity').val();
      const variantId = cartItemElm.data('variant-id').toString();
      const linePrice = newPrice * qty;

      if(partnerPrice) {
        cartItemElm.data('new-price', newPrice);
      }
      
      if(price === newPrice) return linePrice;
      
      const data = {
        quantity: qty,
        id: variantId,
        line: idx + 1,
        properties: {
          '_new_line_price': linePrice
        }
      };
      
      $.ajax({
        method: 'POST',
        async: false,
        url: '/cart/change.js',
        dataType: 'json',
        data: data
      })
      .then(() => {})
      .catch(() => {});

      // update price ==> format money
      cartItemElm.find('.cart-item__unit-price').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat));
      cartItemElm.find('.cart-item__line-price').html(Shopify.formatMoney(linePrice, window.theme.moneyFormat));

      return linePrice;
    };

    // ValidatePartnerQuota from OMS
    function ValidatePartnerQuota(isErr) {
      $.ajax({
        method: 'GET',
        url: '/cart.js',
        dataType: 'json'
      }).then(function(cart) {
        const newCartItems = cart.items?.filter(ele => ele.properties['_new_line_price'] && ele.properties['_new_line_price'] != 'NaN');

          getValidatePartnerQuota(newCartItems, function(result) {
            if(result && result.validTotalQuota.toLowerCase() === "false") {
              const errMesg = `
                <div id="errorValidateQuota">
                  <span style="color: red">The total/yearly quota has exceeded.</span>
                </div>
              `;
  
              $(errMesg).insertAfter("nav.breadcrumb");
  
              if(isErr) {
                $("html, body").animate({ scrollTop: 0 }, "normal");
              }
  
              return;
            }
  
            if (result) {
              const arrayInValidVariantIds = JSON.parse(result.inValidVariantIds.replace(',]', ']'));
  
              if (arrayInValidVariantIds && arrayInValidVariantIds.length > 0) {
                let hasError = false;
  
                arrayInValidVariantIds.forEach(v => {
                  const dataItem = cart.items.find(item => item.variant_id == v);
  
                  if (dataItem) {
                    $(`.cart-item[data-variant-id=${v}]`).find('.quantity-selector .error_Msg').addClass('has-error').text('has exceeded category quota').show();
  
                    $(`.cart-item[data-variant-id=${v}]`).find('.quantity-selector .quantity-selector__current-quantity').addClass('has-error');

                    hasError = true;
                  }
                  else {
                    $(`.cart-item[data-variant-id=${v}]`).find('.quantity-selector .error_Msg').removeClass('has-error').text('').hide();
                    $(`.cart-item[data-variant-id=${v}]`).find('.quantity-selector .quantity-selector__current-quantity').removeClass('has-error');
                  }
                });
  
                if(isErr) {
                  $("html, body").animate({ scrollTop: 0 }, "normal");
                }
  
                if(hasError) {
                  return;
                }
              }
  
              $('#errorValidateQuota').remove();
              $('.quantity-selector .error_Msg').removeClass("has-error");
              
            }
          });

      });
    }

    ValidatePartnerQuota();
    getPriceForCartItems();

    var config = {
      checkoutButton: '#CheckoutButton'
    };
  
    const customerInfoElm = $('#customer-infor');
    const loginPage = 'https://stg.login.sony-asia.com/f3579197-f659-4e21-9ab7-81c873b202e9/oauth2/v2.0/authorize?p=B2C_1_PartnerTH_STG_si_su&client_id=ed731b63-a846-4faa-a08f-ab683217b445&nonce=defaultNonce&redirect_uri=https://uat-pdp.sony.co.th/storeapi/partners/56125325377/auth&scope=openid&response_type=id_token&prompt=login&response_mode=form_post';
    // const staffLoginPage = 'pages/staff';
  
    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      partnerType: customerInfoElm.data('partner-type'),
      customerEmail: customerInfoElm.data('customer-email'),
      firstName: customerInfoElm.data('first-name'),
      lastName: customerInfoElm.data('last-name'),
    }
  
    $(config.checkoutButton).on('click', function(e) {
      e.preventDefault();

      var self = $(this);

      self.addClass('button--loading');

      const storeId = window.partner.storeId.toString();
  
      // check if partnerType does not exist
      if (!customerInfo.partnerType) {
        if (!customerInfo.partnerCode) {
          customerInfo.partnerType = "Staff";
        }
        else {
          customerInfo.partnerType = "Partner";
        }
      }
  
      // set param and url
      let url = '';
      let data = {};
  
      if (customerInfo.partnerType.toLowerCase() == "staff") {
        url = window.partner.omsValidateStaffPartnerCode;
        data = {
          storeid: storeId,
          customeremail: customerInfo.customerEmail,
        }
      }
      else {
        url = window.partner.omsValidateCustomerPartnerCode;
        data = {
          storeid: storeId,
          customeremail: customerInfo.customerEmail,
          partnercode: customerInfo.partnerCode,
          firstname: customerInfo.firstName || '',
          lastname: customerInfo.lastName || '',
        }
      }
      
      // call API
        $.ajax({
          method: 'POST',
          async: false,
          url: `${url}`,
          headers: {
            'Ocp-Apim-Subscription-Key': window.partner.omsApimSubscriptionKey,
            'issuer': storeId,
            'Accept-Language': 'en-US'
          },
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(data)
    
        }).done(result => {
          if (result) {
            const valueResult = JSON.parse(result.value);
            if (customerInfo.partnerType.toLowerCase() == "staff") {
              if (!valueResult.isValid) {
                logoutPartner(valueResult.errorMessage);
  
                return;
              }
            }
            else {
              const endDate = valueResult.promotionEndDate.split("-");
              const endDateTime = new Date(endDate[0], endDate[1] - 1, endDate[2], 23, 59, 59);
              if (!valueResult.isValid || new Date() > endDateTime) {
                logoutPartner(valueResult.errorMessage);
  
                return;
              }
            }
  
            $('#errorValidateQuota').remove();
            $('.quantity-selector .error_Msg').removeClass("has-error");
        
            window.location.href = window.theme.isDefaultLanguage ? '/checkout' : `/${window.theme.locale}/checkout`;
  
            // ValidatePartnerQuota(true);
  
          }
        }).fail(err => {
          console.log('err: ', err);
          return false;
        }).always(() => {
          self.removeClass('button--loading');
        });

  
    });
  
    function logoutPartner(errMsg) {
      const localeValue = window.theme.locale;

      localStorage.setItem('language', localeValue);

      $.ajax('/account/logout').done(() => {
        var errMsgQS = errMsg ? `&login_error=${errMsg.replaceAll(' ', '-')}` : '';

        if(customerInfo.partnerType.toLowerCase() === 'staff') {
          // Login Staff Partner
          // window.top.location.href = document.documentElement.lang === 'th' ? `${window.partner.baseDomain}/th/${staffLoginPage}` : `${window.partner.baseDomain}/${staffLoginPage}`;
          window.top.location.href = document.documentElement.lang === 'th' ? `${loginPage}&ui_locales=th&partner_type=staff${errMsgQS}` : `${loginPage}&ui_locales=en&partner_type=staff${errMsgQS}`;
        }
        else {
          // Login Customer Partner
          window.top.location.href = document.documentElement.lang === 'th' ? `${loginPage}&ui_locales=th${errMsgQS}` : `${loginPage}&ui_locales=en${errMsgQS}`;
        };
      })
    };

  }());

});

router.route(locale?.concat('collections/*type'), function() {
  /**
     * -------------------------
     * SORT BY AND SEARCH
     * -------------------------
     */

  (function() {
    Shopify.queryParams = {};
    var bindFilters = function() {
      $('.collection-sort-by select').val(window.theme.collectionSortBy).on('change', function () {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = $.param(Shopify.queryParams);
      });

      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');

          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $('#collection-tag-filter, #collection-type-filter').on('change', function (event) {
        window.location.href = $(event.currentTarget).find(':selected').val();
      });
    };

    bindFilters();

    $(document).on('shopify:section:load', function(event) {
      bindFilters();
    });
  }());
});

/**
   * ----------------------------------------------------------------------------------------------------
   * GIFT CARDS
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('gift_cards/*id'), function() {
  (function() {
    var config = {
      qrCode: '#QrCode',
      printButton: '#PrintGiftCard',
      giftCardCode: '#GiftCardDigits'
    };

    var $qrCode = $(config.qrCode);

    new QRCode($qrCode[0], {
      text: $qrCode.attr('data-identifier'),
      width: 175,
      height: 175
    });

    $(config.printButton).on('click', function() {
      window.print();
    });

    // Auto-select gift card code on click, based on ID passed to the function
    $(config.giftCardCode).on('click', {element: 'GiftCardDigits'}, selectText);

    function selectText(evt) {
      var text = document.getElementById(evt.data.element);
      var range = '';

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      } else if (window.getSelection) {
        var selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }());
});

/**
   * ----------------------------------------------------------------------------------------------------
   * HOME PAGE
   * ----------------------------------------------------------------------------------------------------
   */

router.route(window.theme.isDefaultLanguage ? '' : window.theme.locale, function() {
  /**
     * -------------------------
     * SLIDESHOW
     * -------------------------
     */

  (function() {
    var initFullScreenSlideshow = function(slideshow) {
      if($( window ).width() <= 480){
        const heightBanner = $( window ).width() * 4/3;
        $('.aspect-ratio.aspect-ratio_mb').css('height', heightBanner);
        $('.fs-slideshow__plyr-container .plyr-video').css('height', heightBanner);
      }
     
      slideshow.slick({
        dots: true,
        dotsClass: 'slider-dots',
        arrow: true,
        pauseOnHover: false,
        accessibility: false,
        adaptiveHeight: true,
        useTransform: true,
        useCSS: true,
        autoplay: (slideshow.attr('data-autoplay') === 'true'),
        autoplaySpeed: parseInt(slideshow.attr('data-cycle-speed')),
        prevArrow: '<button alt="Prev" title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
        nextArrow: '<button alt="Next" title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>'
      });

      // Setup video, if any

      var players = plyr.setup(slideshow.find('.plyr-video[data-type]'), {
        controls: ['play-large'],
        iconPrefix: 'icon-video'
      }) || [];

      players.forEach(function(player) {
        player.on('play', function() {
          slideshow.closest('.fs-slideshow').addClass('fs-slideshow--video-playing');
          slideshow.slick('pause');
        });

        player.on('pause ended', function() {
          slideshow.closest('.fs-slideshow').removeClass('fs-slideshow--video-playing');
          slideshow.slick('play');
        });
      });

      slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // We need to pause any video if any is playing
        players.forEach(function(player) {
          player.pause();
        });
      });
    };

    // Trademark has two different slideshows: a "dual" one that is quite complex and a full-screen that is simpler to implement. When this change,
    // we either init one or the other
    $('.slideshow-section').each(function(index, item) {
      var slideshowSection = $(item),
          slideshowType = slideshowSection.attr('data-slideshow-type');

      if (slideshowType === 'dual') {
        slideshowSection.find('.dual-slideshow').trademarkHomeSlideshow();
      } else {
        initFullScreenSlideshow(slideshowSection.find('.fs-slideshow__slides'));
      }
    });

    $(document).on('shopify:section:unload', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).find('.slideshow-section');

      // If previous slideshow was dual, we have to delete the plugin completely (which will free the memory)
      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow').destroy();
      } else {
        // Otherwise, logic is a bit simpler and we just call slick to delete
        slideshowSection.find('.fs-slideshow__slides').slick('unslick');
      }
    });

    $(document).on('shopify:section:load', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).find('.slideshow-section');

      // If slideshow is dual we need to instantiate the whole plugin, otherwise setup is simpler
      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').trademarkHomeSlideshow();
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        initFullScreenSlideshow(slideshow);
      }
    });

    $(document).on('shopify:block:select', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).closest('.slideshow-section');

      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        var slideshow = slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow');

        slideshow.pause();
        slideshow.goToSlide($(event.target).attr('data-slide-index'));
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        slideshow.slick('goTo', $(event.target).attr('data-slide-index'));

        if (slideshow.attr('data-autoplay') === 'true') {
          slideshow.slick('pause');
        }
      }
    });

    $(document).on('shopify:block:deselect', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).closest('.slideshow-section');

      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow').play();
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        if (slideshow.attr('data-autoplay') === 'true') {
          slideshow.slick('play');
        }
      }
    });
  }());
});

/**
   * ----------------------------------------------------------------------------------------------------
   * REGISTER
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('account/register'), function() {
  var form = $('#create_customer');

  function validateRegisterForm() {
    form.validate({
      rules: {
        'customer[first_name]': {
          required: true,
        },
        'customer[last_name]': {
          required: true,
        },
        'customer[birthday]': {
          required: true,
          date: true,
          birthday_date: true,
        },
        'customer[email]': {
          required: true,
          email: true,
          email_limit: true
        },
        'customer[phone]': {
          required: true,
        },
        'customer[policy]': {
          required: true,
        }
      },
  
      messages: {
        'customer[birthday]': {
          required: window.languages.field_required,
          date: "Please enter a valid date in the format MM/DD/YYYY",
          birthday_date: "Please enter a valid date in the format MM/DD/YYYY",
        },
        'customer[email]': {
          email_limit: window.languages.email_limit,
        }
      }
    });
  
    $.validator.addMethod('birthday_date', function(value) {
      return value.match(/^(0[1-9]|1[012])[\/|-](0[1-9]|[12][0-9]|3[01])[\/|-](19\d\d|2\d\d\d)$/);
    });
    
    $.validator.addMethod('email_limit', function(value) {
      return value.split('@')[0].length <= 64;
    });
  }

  function handleSignUp(self) {
    var email = $('input[name="customer[email]"]').val();
    // var token = $('textarea[name="g-recaptcha-response"]').val();
    var formErrElm = $('.reg--error');
    var errElm = $('[data-err-message]');
    var errTitleElm = errElm.find('.reg--error--title');

    hideError(formErrElm, errTitleElm);
    errElm.css('background-color', '');

    // Intergrate GG Recaptcha V3
    grecaptcha.ready(function() {
      grecaptcha.execute(window.ggrecaptcha.site_key, {action: 'submit'}).then(function(token) {

        if (!token) {
          showError(errElm, errTitleElm, window.theme.isDefaultLanguage ? 'Please check the reCAPTCHA.' : 'โปรดตรวจสอบ reCAPTCHA');
          return false;
        }
        else {
          hideError(formErrElm, errTitleElm);
        };

        let pageUrl = window.location.search.substring(1);
        let urlVariable = pageUrl.split('&');
        let urlInfo = {};

        for (let entry of urlVariable) {
          let pair = entry.split("=");
          urlInfo[pair[0]] = pair[1];
        }

        if (pageUrl) {
          if (urlInfo?.ipd !== '' && urlInfo?.social_id !== '') {
            $('input[name="customer[first_name]"]').val(decodeURI(urlInfo?.firstName));
            $('input[name="customer[last_name]"]').val(decodeURI(urlInfo?.lastName));
            $('input[name="customer[email]"]').val(urlInfo?.email);
          }
        };

        const phoneNumber = $('input[name="customer[phone]"]').val();
        var postData = {
          "origin": "TH",
          "email": email,
          "is_term": true,
          "reCAPTCHA": token,
          "locale": `${window.theme.locale}_TH`,
          "email_subcribe": $("#latest").prop('checked'),
          /** INFO: replace 0 before phone number with prefix code*/
          'phone': phoneNumber.charAt(0) === '0' ? `+66${phoneNumber.slice(1, phoneNumber.length)}` : phoneNumber,
          "bod": $('input[name="customer[birthday]"]').val(),
          "last_name": $('input[name="customer[last_name]"]').val(),
          "first_name": $('input[name="customer[first_name]"]').val(),
          "partner_code": $('input[name="customer[partner_code]"]').val()
        }

        if (pageUrl) {
          postData['social_id'] = urlInfo?.social_id;
          postData['idp'] = urlInfo?.idp;
        }

        self.addClass('button--loading');
        self.prop('disabled', true);

        hideError(formErrElm, errTitleElm);
        errElm.css('background-color', '');

        const apiRequest = new ApiFetch(true);

        apiRequest.post('sign-up', postData)
          .then(function(res){
            if (res.status) {
              fbq('track', 'CompleteRegistration');
              showError(errElm, errTitleElm, res.message);
              errElm.css('background-color', '#2E9E55');

              return;
            }

            if(res.message === 'Account is disabled') {
              $(form).submit();
              return;
            } 

            if(res.message === "Account Exist - Please Login" 
              || res.message === "Account Exist - Please Login." 
              || res.message === "Account exist error"
            ) {
              res.message = window.languages.accountExisted;
            }

            showError(errElm, errTitleElm, res.message);
          })
          .fail(function(err) {
            console.log('fail', err);
          })
          .always(function(e){
            self.removeClass('button--loading');
            self.prop('disabled', false);
          });
      });
    });
  }

  validateRegisterForm();

  $("#btnSignUp").click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handleSignUp($(this));
  });
});

/**
   * ----------------------------------------------------------------------------------------------------
   * VALIDATE PARTNER CODE
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('pages/partner-code'), function() {
  function checkLangToSwitchLogin() {
    const previousLocale = localStorage.getItem("language");

    if(previousLocale === 'th') {
      const { pathname,search } = window.location ?? {};

      localStorage.removeItem("language");

      window.location.href = `/th${pathname}${search}`;
    }
  }

  function renderErrorTpl({form, errMesg}) {
    const err_html = `
      <div class="alert alert--error">
        <span class="alert__title">${errMesg}</span>
      </div>
    `;

    const formControl = form.find('.box__button-wrapper');

    $(err_html).insertBefore(formControl);
  }

  function validateCustomerPartnerCode() {
    const form = $('#validate-partner-code');
    const btnElm = form.find('.submit-form');

    btnElm.off('click.validateCustomerPartnerCode').on('click.validateCustomerPartnerCode', function (e) {
      e.preventDefault();

      const self = $(this);

      self.addClass('button--loading');
      self.prop('disabled', true);

      $('.alert--error').remove();

      const partnerCodeValue = form.find('#partner-code').val().trim();

      if (!partnerCodeValue) {
        renderErrorTpl({
          form,
          errMesg: 'Invalid partner code'
        });
        
        self.removeClass('button--loading');
        self.prop('disabled', false);
      } 
      else {
        const data = {
          "partnerCode": partnerCodeValue
        };

        const url = window.theme.isDefaultLanguage ? `ValidateCustomerPartnerCode` : `ValidateCustomerPartnerCode?locale=${window.theme.locale}_TH`;

        const apiRequest = new ApiFetch();
        apiRequest.post(`validate-partner-code?locale=${window.theme.locale}_TH`, data)
          .then(function (res) {
            if (!res.status) {
              if(res.message === 'This session has expired. Please back to login!') {
                const partnerType = $('#customer-infor').data('partner-type');
                const loginPage = `https://stg.login.sony-asia.com/f3579197-f659-4e21-9ab7-81c873b202e9/oauth2/v2.0/authorize?p=B2C_1_PartnerTH_STG_si_su&client_id=ed731b63-a846-4faa-a08f-ab683217b445&nonce=defaultNonce&redirect_uri=https://uat-pdp.sony.co.th/storeapi/partners/56125325377/auth&scope=openid&response_type=id_token&prompt=login&response_mode=form_post`;
                const staffLoginPage = 'pages/staff';

                if(partnerType === 'staff') {
                  // Login Staff Partner
                  window.top.location.href = document.documentElement.lang === 'th' ? `${window.partner.baseDomain}/th/${staffLoginPage}` : `${window.partner.baseDomain}/${staffLoginPage}`;
                }
                else {
                  // Login Customer Partner
                  window.top.location.href = document.documentElement.lang === 'th' ? `${loginPage}&ui_locales=th` : `${loginPage}&ui_locales=en`;
                };
              }
              else {
                renderErrorTpl({
                  form,
                  errMesg: res.message
                });
              }
            }
            else {
              window.location.href = res.data;
            }
          })
          .fail(function(err) {
            console.log('fail', err);
          })
          .always(function(e){
            self.removeClass('button--loading');
            self.prop('disabled', false);
          });
      }
    })
  }

  checkLangToSwitchLogin();
  validateCustomerPartnerCode();
});

/**
   * ----------------------------------------------------------------------------------------------------
   * ACTIVATE ACCOUNT
   * ----------------------------------------------------------------------------------------------------
   */
router.route(locale?.concat('account/activate/*all'), function() {
  var form = $('[data-actions="activate-account"]');

  function validateActivateForm() {
    form.validate({
      rules: {
        'customer[password]': { 
          required: true,
          rangelength: [8, 20],
          pwcheck: window.languages.invalid_password,
        },
        'customer[password_confirmation]': {
          required: true,
          rangelength: [8, 20],
          equalTo: "#password",
        }
      }
    });
  
    $.validator.addMethod("pwcheck", function(value, element) {
      return /^[A-Za-z0-9\d=!\-@._#&%*]*$/.test(value) // consists of only these
      && /[a-z]/.test(value) // has a lowercase letter
      && /[A-Z]/.test(value) // has a uppercase letter
      && /\d/.test(value) // has a digit
      && /[!\-@._#&%*]/.test(value) //has one special character without space 
    }, window.languages.invalid_password);
  }

  function handleActiveAccount(btn) {
    const customerId = window.theme.isDefaultLanguage ? window.location.pathname.split("/")[3] : window.location.pathname.split("/")[4];
    const psw = form.find('[name="customer[password]"]').val().trim();
    const pswConfirm = form.find('[name="customer[password_confirmation]"]').val().trim();

    if(psw != pswConfirm){
      alert("password confirmation is not the same");
      return false;
    };

    var errElm = $('.reg--error');
    var errTitleElm = errElm.find('.reg--error--title');

    btn.addClass('button--loading');
    btn.prop('disabled', true);

    const data = {
      "id": customerId, 
      "password": psw 
    };

    hideError(errElm, errTitleElm);
    errElm.removeClass('alert--error alert--success');

    const url = window.theme.isDefaultLanguage ? `active-account` : `active-account?locale=${window.theme.locale}`;

    const apiRequest = new ApiFetch(true);
    apiRequest.post(url, data)
      .then(function(res){
        if (res.status) {
          showError(errElm, errTitleElm, 'Active account successfully');
          errElm.removeClass('alert--error')
                .addClass('alert--success');

          setTimeout(function() {
            window.location.href = res.data;
          }, 1000);
        }
        else {
          errElm.removeClass('alert--success')
                .addClass('alert--error');
          showError(errElm, errTitleElm, res.message);
        }
      })
      .fail(function(err) {
        console.log('fail', err);
      })
      .always(function(e){
        btn.removeClass('button--loading');
        btn.prop('disabled', false);
      });
  }

  validateActivateForm();

  form.find('button[type="submit"]').click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handleActiveAccount($(this));
  });
});

/**
   * ----------------------------------------------------------------------------------------------------
   * EDIT PROFILE
   * ----------------------------------------------------------------------------------------------------
   */
router.route(locale?.concat('pages/edit-customer-profile'), function() {
  var form = $('[data-actions="edit-profile"]');

  function validateEditProfileForm() {
    form.validate({
      rules: {
        'customer[first_name]': {
          required: true,
          maxlength: 50
        },
        'customer[last_name]': {
          required: true,
          maxlength: 50
        },
        'customer[email]': {
          required: true,
          maxlength: 50
        },
        'customer[phone]': {
          required: true,
          maxlength: 15
        }
      }
    });
  }

  function handleEditProfile(self) {
    const id = form.find('#customer-id').val();
    const first_name = form.find('#customer-firstname').val();
    const last_name = form.find('#customer-lastname').val();
    const email = form.find('#customer-email').val();
    const phone = form.find('#customer-phone').val();

    var errElm = $('.alert');
    var errTitleElm = errElm.find('.alert__title');

    self.addClass('button--loading')
        .prop('disabled', true);

    const data = {
      phone,
      last_name,
      first_name,
    }

    hideError(errElm, errTitleElm);

    const apiRequest = new ApiFetch();
    apiRequest.post('update-profile', data)
      .then(function(res){
        if (res.status) {
          errElm.removeClass("alert--error")
                .addClass("alert--success");

          showError(errElm, errTitleElm, window.languages.editProfileSuccess);
        }
        else {
          if(res.message == "Invalid phone number.") {
            res.message = window.languages.edit_phone_invalid;
          }
          else {
            res.message = window.languages.edit_phone_existed;
          };

          errElm.removeClass("alert--success")
                .addClass("alert--error");

          showError(errElm, errTitleElm, res.message);
        };
      })
      .fail(function(err) {
        console.log('fail', err);
      })
      .always(function(e){
        self.removeClass('button--loading')
          .prop('disabled', false);
      });
  }

  validateEditProfileForm();

  form.find(".edit-profile-btn").click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handleEditProfile($(this));
  });
});

/**
   * ----------------------------------------------------------------------------------------------------
   * CHANGE PASSWORD
   * ----------------------------------------------------------------------------------------------------
   */
router.route(locale?.concat('pages/change-password'), function() {
  var form = $('#change-password');

  function validateChangePswForm() {
    form.validate({
      rules: {
        'current_password': {
          required: true,
          rangelength: [8, 20]
        },

        'new_password': {
          required: true,
          rangelength: [8, 20],
          pwcheck: "Password Valid!"
        }
      }
    });
  
    $.validator.addMethod("pwcheck", function(value, element) {
      return /^[A-Za-z0-9\d=!\-@._#&%*]*$/.test(value) // consists of only these
      && /[a-z]/.test(value) // has a lowercase letter
      && /[A-Z]/.test(value) // has a uppercase letter
      && /\d/.test(value) // has a digit
      && /[!\-@._#&%*]/.test(value) //has one special character without space
    }, window.languages.invalid_password);
  }

  function handlePswChange(self) {
    const password = form.find('input[name="new_password"]').val();
    const current_password = form.find('input[name="current_password"]').val();

    var errElm = $('.reg--error');
    var errTitleElm = errElm.find('.reg--error--title');

    self.addClass('button--loading')
        .prop('disabled', true);

    const data = {
      password,
      current_password
    }

    hideError(errElm, errTitleElm);

    const apiRequest = new ApiFetch();
    apiRequest.post('password', data)
      .then(function(res){
        if(res.status === 429) {
          $('.reg--error').removeClass("alert--success").addClass("alert--error");
          $('.reg--error--title').text(res.messageError);
          $('.reg--error').show();
        }
        else {
          if (res.status) {
            res.message = window.languages.change_password_success;

            errElm.removeClass("alert--error")
                  .addClass("alert--success");
          }
          else {
            if(res.message= "Yourpasswordisincorrect") {
              res.message = window.languages.change_password_wrong_pass;
            }
            else if(res.message === "No account found with that email.") {
              res.message = window.languages.change_password_wrong_email;
            }
            else if(res.message === "Password can not change.") {
              res.message = window.languages.change_password_fail;
            };

            errElm.removeClass("alert--success")
                  .addClass("alert--error");
          };

          showError(errElm, errTitleElm, res.message);
        }
      })
      .fail(function(err) {
        console.log('fail', err);
      })
      .always(function(e){
        self.removeClass('button--loading')
            .prop('disabled', false);
      });
  }

  validateChangePswForm();

  $("#btnChangePassword").click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handlePswChange($(this));
  });
});

/**
   * ----------------------------------------------------------------------------------------------------
   * LOGIN FORGOT PSW
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('account/login'), function() {
  function validateEmailRegex(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  function renderErrorTpl({form, errMesg, btn}) {
    const err_html = `
      <div class="alert alert--error">
        <span class="alert__title">
          ${window.theme.isDefaultLanguage ? 'There was some error:' : 'บางอย่างผิดพลาด:'}
        </span>
        <ul class="alert__errors">
          <li class="alert__error">${errMesg}</li>
        </ul>
      </div>
    `;

    const formControl = form.find('.form__control');

    $(err_html).insertBefore(formControl);

    btn.removeClass('button--loading')
          .prop('disabled', false);
  }

  function recoverPassword() {
    const form = $('#recover-password-section').find('form');
    const recoverBtnElm = form.find('.submit-form-recover');

    recoverBtnElm.off('click.recoverPassword').on('click.recoverPassword', function (e) {
      e.preventDefault();

      const self = $(this);

      self.addClass('button--loading')
          .prop('disabled', true);

      $('.alert--error').remove();
      $('.alert--success').remove();

      const email = form.find('[name="email"]').val().trim();
      let errMsg = "";

      if (!email) {
        errMsg = window.theme.isDefaultLanguage ? 'This field is required' : 'ฟิลด์นี้จำเป็น'
      }
      else if (!validateEmailRegex(email)) {
        errMsg = window.theme.isDefaultLanguage ? 'Invalid email' : 'อีเมลไม่ถูกต้อง'
      }

      if (errMsg) {
        // showError
        renderErrorTpl({
          form,
          btn: self,
          errMesg: errMsg
        });  
        return;
      }

      // const token = form.find('textarea[name="g-recaptcha-response"]').val();

      // Intergrate GG Recaptcha V3
      grecaptcha.ready(function() {
        grecaptcha.execute(window.ggrecaptcha.site_key, {action: 'submit'}).then(function(token) {

          if (!token || token === '') {
            renderErrorTpl({
              form, 
              btn: self,
              errMesg: window.theme.isDefaultLanguage ? 'Please check the reCAPTCHA.' : 'โปรดตรวจสอบ reCAPTCHA'
            }); 

            return false;
          };
          
          const data = { 
            email, 
            reCAPTCHA: token 
          };

          const apiRequest = new ApiFetch(true);
          apiRequest.post('validate-email', data)
            .then(function (res) {
              if (!res.status) {
                let errMesg = res.message;

                if(!window.theme.isDefaultLanguage) {
                  if(errMesg === 'The account with that email was not found.') {
                    errMesg = 'ไม่พบบัญชีที่มีอีเมล';
                  }
                }

                renderErrorTpl({
                  form, 
                  btn: self,
                  errMesg
                }); 
                return;
              }

              form.submit();
              
            })
            .fail(function(err) {
              console.log('fail', err);
            })
            .always(function(e){
              self.removeClass('button--loading')
                .prop('disabled', false);
            });   
        });
      });
    })
  }

  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  recoverPassword();
});

/**
   * ----------------------------------------------------------------------------------------------------
   * RESET PSW
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('pages/reset-password'), function() {
  var form = $('[data-actions="reset-password"]');

  function validateResetPswForm() {
    form.validate({
      rules: {
        'customer[password]': { 
          required: true,
          rangelength: [8, 20],
          pwcheck: window.languages.invalid_password,
        },
        'customer[password_confirmation]': {
          required: true,
          rangelength: [8, 20],
          equalTo: "#password",
        }
      }
    });

    $.validator.addMethod("pwcheck", function(value, element) {
      return /^[A-Za-z0-9\d=!\-@._#&%*]*$/.test(value) // consists of only these
      && /[a-z]/.test(value) // has a lowercase letter
      && /[A-Z]/.test(value) // has a uppercase letter
      && /\d/.test(value) // has a digit
      && /[!\-@._#&%*]/.test(value) //has one special character without space 
    }, window.languages.invalid_password);
  }

  function handleResetPsw(self) {
    const tokenUser = document.cookie.split("; ").find((e=>e.startsWith("tokenUser=")));
    const tokenValue = tokenUser ? tokenUser.split("=")[1] : null;

    var newPassword = form.find('input[name="customer[password]"]').val();

    var errElm = $('.reg--error');
    var errTitleElm = errElm.find('.reg--error--title');
    
    self.addClass('button--loading')
        .prop('disabled', true);
        
    errElm.removeClass('alert--error alert--success');
    hideError(errElm, errTitleElm);

    const apiFetch = new ApiFetch(true);
    apiFetch.put('reset-pwd',{
      id: tokenValue,
      password: newPassword
    }).then(function(res){
      if (res.status) {
        errElm.addClass('alert--success');
        showError(errElm, errTitleElm, window.languages.reset_password_success);

        setTimeout(function() {
          window.location.href = `https://stg.login.sony-asia.com/f3579197-f659-4e21-9ab7-81c873b202e9/oauth2/v2.0/authorize?p=B2C_1_PartnerTH_STG_si_su&client_id=ed731b63-a846-4faa-a08f-ab683217b445&nonce=defaultNonce&redirect_uri=https://uat-pdp.sony.co.th/storeapi/partners/56125325377/auth&scope=openid&response_type=id_token&prompt=login&response_mode=form_post&ui_locales=${document.documentElement.lang === 'th' ? 'th' : 'en'}`;
        }, 1000)
      }
      else {
        errElm.addClass('alert--error');
        showError(errElm, errTitleElm, res.message == "Email is not exist." ? window.languages.reset_no_account : window.languages.can_not_reset);
      }
    })
    .always(function(e){
      self.removeClass('button--loading')
        .prop('disabled', false);
    });
  }

  validateResetPswForm();

  $("#btnReset").click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handleResetPsw($(this));
  });
});

router.route(locale?.concat('password'), function() {
  console.log('run')
  (function() {
    var passwordModal = $('.password-popup');

    $('[data-action="toggle-storefront-password"]').on('click', function() {
      passwordModal.remodal({hashTracking: false}).open();
    });
  })();
});


var productRoute = function() {
  /**
   * -------------------------
   * PRODUCT SLIDESHOW
   * -------------------------
   */

  (function() {
    var initProductSlideshow = function(domElement) {
      if (domElement.length === 0) {
          return;
      }

      var productSlideshow = domElement,
          productSlides = productSlideshow.find('.product__slides'),
          productThumbnails = domElement.find('.product__thumbnails');

      productSlides.slick({
          adaptiveHeight: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: parseInt(productSlides.attr('data-initial-slide')),
          arrows: true,
          dots: false,
          useTransform: true,
          asNavFor: productThumbnails,
          infinite: true,
          prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
          nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
      });

      productSlides.on('beforeChange', function(event, slick, currentPosition, nextPosition) {
            
            productThumbnails.find('.product__thumbnail').removeClass('product__thumbnail--active')
                .eq(nextPosition)
                .addClass('product__thumbnail--active');
            productThumbnails.find('.product__thumbnail').each(function(value) {
              var thumbnail = $(this);
              let indexSlider = thumbnail[0].getAttribute('data-slide-index');
              if (parseInt(indexSlider) === parseInt(nextPosition)) {
                  thumbnail.addClass('product__thumbnail--active');

              } else {
                  if (thumbnail.hasClass('product__thumbnail--active')) {
                    thumbnail.removeClass('product__thumbnail--active');
                  }
              }

          });
      });
    
      productThumbnails.find('.product__thumbnail').on('click', function(event) {
          var thumbnail = $(this);
  

          thumbnail.addClass('product__thumbnail--active');
          thumbnail.siblings().removeClass('product__thumbnail--active');

          productSlides.slick('slickGoTo', $(this).attr('data-slide-index'));
          event.preventDefault();
      });
          
      // If image zoom is enabled we also allow to open the images in a lightbox
      if (productSlideshow.attr('data-enable-image-zoom') === 'true' && Modernizr.mq('(min-width: 801px)')) {
          productSlides.magnificPopup({
              delegate: '.product__slide:not(.product__slide--video)',
              type: 'image',
              gallery: {
                  enabled: true,
                  arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="icon icon-arrow-%dir% mfp-prevent-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-%dir%"></use></svg></button>'
              }
          });
      }
    };

    initProductSlideshow($('.product__slideshow'));

    $(document).on('shopify:section:unload', '#shopify-section-product-template', function(event) {
      $(event.target).find('.product__slides').slick('unslick');
      $(event.target).find('.product__thumbnail').off('click');
    });

    $(document).on('shopify:section:load', '#shopify-section-product-template', function(event) {
      initProductSlideshow($(event.target).find('.product__slideshow'));
    });
  }());

  /**
   * -------------------------
   * PRODUCT TABS
   * -------------------------
   */

  (function() {
    var initProductTabs = function(domElement) {

      if (domElement.length === 0) {
        return;
      }

      domElement.trademarkTabs();
    };

    initProductTabs($('.product__tabs'));

    $(document).on('shopify:section:unload', '#shopify-section-product-template', function(event) {
      $(event.target).find('.product__tabs').data('plugin_trademarkTabs').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-product-template', function(event) {
      initProductTabs($(event.target).find('.product__tabs'));
    });
  }());

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
   */

  (function() {
    var initProducts = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.slick({
        accessibility: false,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        mobileFirst: true,
        infinite: false,
        slidesToShow: 1,
      	slidesToScroll: 1,
        useCSS: true,
        prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
        nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
        responsive: [
		      {
            breakpoint: 320,
            settings: 'unslick'
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1349,
            settings: {
              slidesToShow: 6
            }
          }
        ]
      })
    };

    initProducts($('[data-related-products-slider]'));

    $(document).on('shopify:section:unload', '.shopify-section__related-products-slider', function(event) {
      $(event.target).find('[data-related-products-slider]').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__related-products-slider', function(event) {
      initProducts($(event.target).find('[data-related-products-slider]'));
    });

    var winWidth = $(window).innerWidth();
    var resizeTimerId;

    $(window).on('resize orientationChange', function() {
      clearTimeout(resizeTimerId);

      resizeTimerId = setTimeout(function() {
        var curWinWidth = $(window).innerWidth();

        if (curWinWidth < 320 && winWidth >= 320) {
          initProducts($('[data-related-products-slider]'));
        }
        else if(curWinWidth >= 768 && winWidth < 768) {
          initProducts($('[data-related-products-slider]'));
        }

        winWidth = curWinWidth;
      }, 200);
    });
  }());
};

/**
   * ----------------------------------------------------------------------------------------------------
   * PRODUCT ROUTE
   * ----------------------------------------------------------------------------------------------------
   */

router.route(locale?.concat('products/*type'), productRoute);
router.route(locale?.concat('collections/*collection/products/*type'), productRoute);
router.route(locale?.concat('products_preview'), productRoute);
